import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, NgZone, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title, DomSanitizer, Meta, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subject } from 'rxjs';
import { Constant } from 'src/app/constants/constant';
import { conditionalValidator, noWhitespaceValidator } from 'src/app/pages/util/calsoft-validators';
import { AboutService } from 'src/app/services/about.service';
import { CartService } from 'src/app/services/cart.service';
import { CheckoutService } from 'src/app/services/checkout.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { DeliverySlotsService } from 'src/app/services/delivery-slots.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PaymentService } from 'src/app/services/payment-service';
import { PincodeService } from 'src/app/services/pincode.service';
import { PixelService } from 'src/app/services/pixel.service';
import { ShippingRateService } from 'src/app/services/shipping-rate.service';
import { UrlService } from 'src/app/services/url-service.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard'
import { MatTabChangeEvent } from '@angular/material/tabs';
import upiqr from 'upiqr';
import { MatSelectChange } from '@angular/material/select';
import { isNumeric } from 'src/app/shared/utils/calsoft-validators';
import { take, takeUntil } from 'rxjs/operators';
import { User } from 'src/app/models/user';
import { LocationComponent } from 'src/app/shared/location/location.component';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { GoogleMapService } from 'src/app/services/google-map.service';
import { CartItem, SalesFlatQuoteItem } from 'src/app/models/cart-item';
import { PhonePeService } from 'src/app/services/phone-pe.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { SalescartService } from 'src/app/services/salescart.service';
import { ProductService } from 'src/app/services/product.service';
import { NoitemComponent } from 'src/app/theme/cart-layout/noitem/noitem.component';
interface MenuItem {
  id: string;
  name: string;
  description?: string;
  price: number;
  imageUrl: string;
  isVeg: boolean;
  quantity?: number; // Quantity for items in the cart
}

interface CouponOffer {
  id: string;
  name: string;
  iconUrl: string;
  description: string;
  terms: string;
}
interface Address {
  id: string;
  type: string; // e.g., "Home", "Work", "Other"
  fullAddress: string;
  description: string;
  iconPath: string; // SVG path for the address type icon
}

@Component({
  selector: 'app-swiggy-cart',
  templateUrl: './swiggy-cart.component.html',
  styleUrls: ['./swiggy-cart.component.scss']
})
export class SwiggyCartComponent {
  currentView: 'cart' | 'coupon' | 'addressForm' | 'payment' | 'address' = 'cart'; // 'cart', 'coupon', 'payment', or 'address'

  selectedLocation: string = 'Select An Addresss'; // Initial 
  selectedAddressId: string | null = null; // To track the currently selected address
  isBillDetailsExpanded: boolean = true;

  public serverPath1 = environment.commonImageApi + 'qrcode/';
  @Input() typepay: string;
  @Input('price') price: Array<object> = [];
  billingForm: UntypedFormGroup;
  deliveryForm: UntypedFormGroup;
  paymentForm: UntypedFormGroup;
  countries = [];
  months = [];
  years = [];
  deliveryMethods = [];
  grandTotal: any = 0;
  consultationFees: any = 0;
  freeConsultation: any;
  value1: any;
  total: any;
  selectedAddres = [];
  salesflatOrder: any = [];
  salesFlatInvoice: any;
  salesflatQuote: any[];
  salesFlatQuoteAddress: any;
  results: any[];

  public serverPath = environment.commonImageApi;
  salesFlatOrderItem: any;
  loginChange: boolean;
  index: any;
  username: any;
  checkOutAddress: any;
  delieveryCharge: any = 0.0;
  grandTotalWithoutShippingCharge: any;
  countryId: any;
  countryCode: any;
  defalutValue: number;
  totalWeigth: any;
  method: string;
  payment: string;
  salesFlatOrderPayment: any;

  uae: any;
  countdown: number;
  countdownMapping: any;

  // Private
  private _unsubscribeAll: Subject<any>;
  couponCodevalue: any;
  regionId: any;
  state: any;
  categoryId: any[] = [];
  totalQty: any;
  discountEnabled: boolean = false;
  discountAmt: any;
  myForm: UntypedFormGroup;
  couponResult: any;
  paymentVendor: any = "razorPay";
  customerData: any;
  noProductsPopup: boolean;
  cartCount: any;
  shipmentVendor: string;
  shippingEnabled: number;
  postCode: any;
  freeShippingAppliedAmount: any;
  ownerPostCode: any;
  ownerCountryID: any;
  paymentModes: any = [];
  helpDescription: any;
  enableStorePickup: any;
  storeName: any;
  deliveryAddressLabel: string = "Delivery Address";
  checkoutTimerEnabled: number;
  checkoutTimerSeconds: any;
  calculateShippingRateBasedOnVendors: any;
  additionalDeliveryChargeInPercent: any;
  additionalDeliveryAmount: any;
  loopEnabled: boolean;
  prescriptionRequired: any;
  deliveryOptionList: any;
  storeOptionList: any;
  mediaGallery: any = [];
  imagesToRemoved: any = [];
  text: string;
  medicalTitle: any;
  zoomImage: any;
  previousUrl: string;
  contact: {};
  btnLabeltxt: string = "CONFIRM ORDER";
  submitbtn: string = 'Continue Checkout';

  paritalPayment: any = [
    { "value": 0, "name": "Full Payment" },
    { "value": 1, "name": "Partial Payment" },

  ]
  paritialPaymentEnabled: any = 0;
  paritialPaymentAmount: any;
  paritialPaymentInfo: any;
  calculateParitialAmountPercent: any;
  editParitialAmount: any;
  configData: any;
  vendorEnabled: any = 0;
  conversionId: any;
  skuList: any;
  showGst: any = 0;
  taxAmount: any = 0.0;
  upiImage: any;
  upiLink: any;
  disableCoupoun: any = 0;
  latitude: any;
  longitude: any;
  distance: any;
  distanceSelection: number;
  codPaymentCharge: any;
  additionalPaymentText: any;
  taxName: any;
  codPaymentMessage: string | undefined;
  valueAdded: boolean = false;
  shareChatId: any;
  checkoutPageType: any;
  userNameEnabled: boolean = false;
  loop: any = 0;
  cartData: any;
  priceDetailType: any = 0;
  mrp: any;
  salesFlatOrderItemOption: any = [];
  enableReferalCustomerDiscount: number = 0;
  enableDeliveryTip: any = 0;
  deliveryTipAmount: any = 0;
  tip: number = 0.0;
  enableDeliveryInstuction: any = 0;
  deliverySlots: any;
  orderDeliveryTime: any;
  printDateTime: any;
  printTimeInOrder: any = '30';
  newTime: any;
  deliverySlotEnable: any;
  orderDirectInvoiceEnable: any = 0;
  salesFlatInvoiceItem: any[];
  warehouseBasedAllocation: any;
  selectedTime: any;
  deliverySlotsEnable: boolean = false;
  deliverySlotTiming: any = 30;
  warehouseLatitude: string;
  warehouseLongitude: string;
  deliverySlotPeriod: any = 7;
  shippingAmountName: any = 'Shipping Amount';
  saving: any;
  BaseGrandTotal: any;
  GrandTotal: any;
  paymentVisible: boolean = false;
  configDataNew: any;
  isWhatsApp: boolean = false;
  WhatsAppFullUrl: any;
  WhatsAppPhoneNumber: any;
  isPromoApplied: boolean;
  promoCode: any;
  cartPageLayout: any;
  homePageBuilder: any;
  layoutype: any;
  init: boolean = false;
  mainItem: MenuItem = {
    id: 'biryani',
    name: 'Spicy Chicken Biryani',
    description: 'Basmati Rice',
    price: 398,
    imageUrl: '',
    isVeg: false,
    quantity: 1
  };
  //for Cart Items
  @Input() cartList: CartItem; // Input to receive the entire cart object
  // Properties similar to CommonCartNewComponent that affect display
  public serverPath7 = environment.commonImageApi + "catalog/product/";
  public serverPath12 = environment.commonImageApi + "categoryPageImageLayout/";
  private serverPathAddress = environment.ImageAPI; // Assuming ImageAPI is defined

  categoryPageImageLayout: any;
  skuListCart: any[] = [];
  showGstCart: any = 0;
  showStockInHand: any;
  showExclusivePrice: any = 0;
  displayMrpPrice: any = 0;
  taxNameCart: any;
  priceDetailTypecart: any = 0;
  cartItemListSubChild: any = [];
  MessageEdit: any = 0;
  messageRequired: number = 0;
  cartFormGroup: UntypedFormGroup;

  //For common Address
  firstFormGroup: UntypedFormGroup;
  authourized: any;
  defalutValueAddress: any = 0;
  visible: boolean = true;
  Addressindex: any;
  operation: string;
  guestLoginEnabled: string = "0";
  countryList: any;
  filteredcountryTypeList: any;
  countryFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();
  pinCodeSelection: any;
  country: any;
  deliveryRange: any;
  destinationLat: any;
  destinationLng: any;
  pincodeError: boolean = false;
  commonData: any;
  @Input() type: string;
  @Input() layout: any = 1;

  @Output() onConfirmAddress: EventEmitter<any> = new EventEmitter<any>();
  @Output() getCustomerData: EventEmitter<any> = new EventEmitter<any>();
  // @Output() getAddressDeliverable: EventEmitter<any> = new EventEmitter<any>();

  //For Phone Pe
  finalAmount: any;
  partialAmountEnabled: any;
  email: any;
  ccAvenueUrl: string;
  accessCode: string;
  merchantId: string;
  Enckey: string;
  additionData: string;
  encRequest: any;
  txnId: any;
  encRequestRes: any;
  paymentObject: any;
  paypalLoad: boolean = false;

  //For Razor Pay
  razorKey: string;
  razorpayScriptLoaded: boolean = false;
  razorpayReady: boolean = false;



  mealCategories = [
    { id: 'popular', name: 'Popular' },
    { id: 'desserts', name: 'Desserts' },
    { id: 'sides', name: 'Sides' }
  ];
  selectedCategory: string = 'popular';

  popularItems: MenuItem[] = [
    { id: 'gulab-jamun', name: 'Gulab Jamun', description: '(2 Pcs)', price: 63, imageUrl: 'https://placehold.co/100x100/FFD700/000?text=Gulab', isVeg: true },
    { id: 'coke', name: 'Coke', description: '(500 ML)', price: 99, imageUrl: 'https://placehold.co/100x100/FF0000/FFF?text=Coke', isVeg: true },
    { id: 'sprite', name: 'Sprite', description: '(500 ML)', price: 99, imageUrl: 'https://placehold.co/100x100/00FF00/000?text=Sprite', isVeg: true },
    { id: 'samosa', name: 'Samosa', description: '(2 Pcs)', price: 45, imageUrl: 'https://placehold.co/100x100/8B4513/FFF?text=Samosa', isVeg: true }
  ];

  dessertItems: MenuItem[] = [
    { id: 'brownie', name: 'Chocolate Brownie', description: 'With Ice Cream', price: 120, imageUrl: 'https://placehold.co/100x100/8B4513/FFF?text=Brownie', isVeg: true },
    { id: 'ice-cream', name: 'Vanilla Ice Cream', description: '(Scoop)', price: 80, imageUrl: 'https://placehold.co/100x100/ADD8E6/000?text=Ice+Cream', isVeg: true }
  ];

  sideItems: MenuItem[] = [
    { id: 'raita', name: 'Mix Veg Raita', description: '(150 ML)', price: 50, imageUrl: 'https://placehold.co/100x100/E0FFFF/000?text=Raita', isVeg: true },
    { id: 'salad', name: 'Green Salad', description: 'Freshly Cut', price: 70, imageUrl: 'https://placehold.co/100x100/90EE90/000?text=Salad', isVeg: true }
  ];

  couponOffers: CouponOffer[] = [
    {
      id: 'ppewallet',
      name: 'PPEWALLET',
      iconUrl: 'https://placehold.co/24x24/8A2BE2/FFF?text=P', // Placeholder for PhonePe icon
      description: 'Get flat ₹25 cashback using PhonePe wallet',
      terms: 'Flat ₹25 cashback using PhonePe wallet on transaction amount ₹299 & above'
    },
    {
      id: 'apayfest',
      name: 'APAYFEST',
      iconUrl: 'https://placehold.co/24x24/FFA500/FFF?text=A', // Placeholder for Amazon Pay icon
      description: 'Get upto ₹125 cashback using Amazon Pay Balance',
      terms: 'Up to ₹125 cashback on Amazon Pay Balance transactions above ₹249'
    },
    {
      id: 'mbkfest',
      name: 'MBKFEST',
      iconUrl: 'https://placehold.co/24x24/FF00FF/FFF?text=M', // Placeholder for Mobikwik icon
      description: 'Get upto ₹150 cashback using Mobikwik wallet',
      terms: 'Up to ₹150 cashback on Mobikwik wallet transactions above ₹249'
    }
  ];

  upiOptions: any[] = [
    {
      id: 'phonepe-upi',
      name: 'PhonePe UPI',
      iconUrl: 'https://placehold.co/24x24/5A31F4/FFF?text=Ph',
      description: 'Fast and secure UPI payments with cashback offers',
      radio: true
    },
    // {
    //   id: 'ccavenue',
    //   name: 'CCAvenue',
    //   iconUrl: 'https://placehold.co/24x24/0A6EB4/FFF?text=CC',
    //   description: 'Secure credit/debit card and UPI payments via CCAvenue',
    //   radio: true
    // },
    // {
    //   id: 'easebuzz',
    //   name: 'Easebuzz',
    //   iconUrl: 'https://placehold.co/24x24/9C27B0/FFF?text=EB',
    //   description: 'Pay using UPI, cards, or netbanking via Easebuzz',
    //   radio: true
    // },
    {
      id: 'razorpay',
      name: 'Razorpay',
      iconUrl: 'https://placehold.co/24x24/3F51B5/FFF?text=RZ',
      description: 'Instant UPI and card payments via Razorpay',
      radio: true
    }
  ];


  morePaymentOptions: any[] = [
    { id: 'wallets', name: 'Wallets', iconPath: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V8h16v10z', description: 'PhonePe, Amazon Pay & more' },
    { id: 'pluxee', name: 'Pluxee', iconPath: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z', description: 'Pluxee card valid only on Food & Instamart' }
  ];
  selectedIndex: any;
  selectedPaymentOption: any;
  selectedPaymentOptionName: any = "";
  qrCodePaymentMode: any;
  couponList: any;
  addressNotFilled: boolean = true;
  orderNaviatedUrl: any = 0;
  orderUrl: any = "/orders";
  cartUpdated: boolean = false;


  getAddressCount(): number {
    const addressArray = this.firstFormGroup.get('address') as UntypedFormArray;
    return addressArray?.controls.length || 0;
  }
  onUpiOptionSelected(option: any): void {
    console.log('Selected UPI Option:', option);
    this.selectedPaymentOption = option.id;
    this.selectedPaymentOptionName = option.name;
    this.hidePaymentScreen();
  }
  selectCashOnDelivery() {
    this.selectedPaymentOptionName = "COD";
    this.hidePaymentScreen();

  }

  savedAddresses: Address[] = [
    {
      id: 'home-address',
      type: 'Home',
      fullAddress: '123, Main Street, Near City Center, Chennai - 600001',
      description: 'Flat 401, Apartment Name, Landmark',
      iconPath: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' // Home icon
    },
    {
      id: 'work-address',
      type: 'Work',
      fullAddress: 'Office Space, Tech Park, OMR Road, Chennai - 600096',
      description: 'Floor 7, Building B, Near Metro Station',
      iconPath: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' // Office icon
    },
    {
      id: 'other-address',
      type: 'Other',
      fullAddress: '456, Gandhi Road, Anna Nagar, Chennai - 600040',
      description: 'Opposite Park, Beside Supermarket',
      iconPath: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-.83 0-1.5-.67-1.5-1.5S11.17 8.5 12 8.5s1.5.67 1.5 1.5S12.83 11.5 12 11.5z' // Location pin icon
    }
  ];

  cartItems: MenuItem[] = []; // To store items added from "Complete Your Meal"

  deliveryDistance: number = 3.0;
  deliveryFee: number = 39.00;
  gstCharges: number = 51.60;
  itemTotal: number = 0;
  totalPay: number = 0;

  getValidTip(tip: any): number {
    return isNaN(tip) ? 0 : tip;
  }

  partialPaymentControl = new UntypedFormControl('Full Payment', []);
  qrCodeReference = new UntypedFormControl('', [Validators.required, noWhitespaceValidator]);
  deliveryAdditionInfo = new UntypedFormControl('', []);

  deliveryType = new FormControl('Standard');

  customerPhoneNo: any;

  ngOnInit(): void {


    let cache = "none";
    this.getCartItems(cache);
    this.initializeForm();
    this.calculateTotals();

    this.getRelatedDate()

    if (this.savedAddresses.length > 0) {
      this.selectedAddressId = this.savedAddresses[0].id;
    }

    const data = JSON.parse(localStorage.getItem('WhatsAppNavData') || '{}');
    if (data.whatsAppPhoneNumber) {
      this.customerPhoneNo = data.customerPhoneNo;
      this.WhatsAppPhoneNumber = data.whatsAppPhoneNumber;
      this.WhatsAppFullUrl = data.whatsAppPhoneNumber
      this.isWhatsApp = true;
    } else {
      console.log('No WhatsApp data found');
    }

    const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configDataNew = JSON.parse(storedConfig);
      if (this.configDataNew != null) {
        this.getConfigData();
      }

    } else {
      console.warn('No config data found in localStorage.');
    }

    let value = this._activatedRoute.snapshot.queryParamMap.get('transaction');

    if (value != null) {
      if (value == "failed") {
        this.snackBar.open('Payment failed. Please try again.', '×',
          { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }

    }
    if (this.urlService.previousUrl['_value'] != null) {
      if (this.urlService.previousUrl['_value'].includes('/cart')) {


        if (this.router.url.includes("type")) {
          this.prescriptionRequired = true;
        } else {
          this.prescriptionRequired = false;
        }
      }

      else if (this.router.url.includes("type")) {
        this.prescriptionRequired = true;
      }
      else {
        this.checkPrescriptionProduct();
      }

    } else {
      this.checkPrescriptionProduct();
    }

    //For Phone Pe 
    this.getPhonePeConfig();

    //For Razor pay
    this.loadRazorpayScript();
    this.getRazorpayConfig();


    //To get the coupon Cart
    this.getCoupon()

    this.warehouseLatitude = localStorage.getItem("dstLat");

    this.warehouseLongitude = localStorage.getItem("dstLon");

    let warehouseId = localStorage.getItem("whs");

    this.titleService.setTitle('Secure Payment | ' + Constant.siteName);
    this.cartServices.cartItemCount().subscribe(

      (count) => {
        console.log("checkoutCount");
        this.cartCount = count;

        if (this.cartCount > 0) {

          this.noProductsPopup = false;
          this.defalutValue = 0;


          this.username = this.userService.getAuthenticatedUser();


          let countryCode = this.currencyConversionService.getCountryCode();
          if (countryCode == null) {
            this.countryCode = "₹";
          }
          else {
            this.countryCode = countryCode;
          }
          this.payment = 'razorPay'
        }
        else {
          this.noProductsPopup = true;

        }
      }, (err) => {
        this.noProductsPopup = false;

      });

    if (this.prescriptionRequired) {

      this.getAllMedicalDeliveryOption();
    }



    this.getAllPaymentModes()
    if (this.deliverySlotEnable == 1) {
      this.getAllDeliverySlots();
    }

    this.tipControl.valueChanges.subscribe(() => {
      this.calculateTotal();
    });
    //this.getAboutData();

    console.log("salesflatOrder", this.salesFlatOrderItem)

    //for common address
    this.configData = {
      currencyBase: 'USD',
      avaliablePincodes: 0,
      country: 'India',
      supplierLatitude: '28.7041',
      supplierLongitude: '77.1025',
      warehouseBasedAllocation: 0,
      googleMapsEnabled: 0,
      deliveryRange: 100,
      checkoutPageType: 1
    };
    this.authourized = this.userService.getAuthenticatedUser(); // Or some other auth check
    this.createUserForm();
    this.getCountryList();
    // this.countrYFilter();
    // this.getAllCountry();
    this.getUserById(cache);
    // this.getCartItems(cache);
    //forcart
    if (this.cartList) {
      this.editCartList(this.cartList);
    }
    this.categoryPageImageLayout = 'assets/images/products/placeholder.jpg';
    this.showGst = 1;
    this.showStockInHand = true;
    this.showExclusivePrice = 1;
    this.displayMrpPrice = 1;
    this.taxName = 'GST';
    this.priceDetailType = 1;
    this.MessageEdit = 0;
    this.messageRequired = 0;
  }

  sortParam: any;

  relaterProductList: any;

  getRelatedDate() {

    const relatedProductIds: number[] = JSON.parse(localStorage.getItem("RelatedProductId")) || [];

    if (relatedProductIds.length === 0) {
      console.warn("No related product IDs found.");
      return;
    }

    this.productService
      .getProductRelatedBySearch(relatedProductIds).subscribe(
        (res) => {
          this.relaterProductList = res;

          console.log("relaterProductList", this.relaterProductList);

        },
        (err) => {
          console.error("Error fetching related products", err);
        }
      );
  }

  constructor(
    public dialogRef: MatDialogRef<SwiggyCartComponent>,
    private pinCodeService: PincodeService,
    private salesCartService: SalescartService,
    private warehouseService: WarehouseService,
    private snackBar: MatSnackBar,
    private aboutService: AboutService,
    private checkOut: CheckoutService,
    private phonePeService: PhonePeService,
    public formBuilder: UntypedFormBuilder,
    private winRef: WindowRefService,
    public userService: UserService,
    public cartService: CartService,
    public router: Router,
    private currencyConversionService: CurrencyConversionService,
    public shippingRateService: ShippingRateService,
    private productService: ProductService,
    private titleService: Title,
    private cartServices: CartService,
    private pincodeService: PincodeService,
    private zone: NgZone,
    private _activatedRoute: ActivatedRoute,
    private configService: ConfigServiceService,
    private paymentService: PaymentService,
    private dialog: MatDialog,
    private urlService: UrlService,
    private commonService: CommonService,
    private pixelService: PixelService,
    private clipboard: Clipboard,
    private sanitizer: DomSanitizer,
    private ecryptService: EcryptServiceService,
    private loaderService: LoaderService,
    private deliverySlotsService: DeliverySlotsService,
    private datePipe: DatePipe,
    private location: Location,
    private maps: GoogleMapService,
    meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {

    this.loaderService.hide();

    meta.addTags([
      { name: 'robots', content: 'noodp' },
      { name: 'robots', content: 'noindex,nofollow' },
    ]);

    this.myForm = formBuilder.group({
      name: [
        '',
        conditionalValidator(
          (() => this.checkoutPageType === 2 || this.checkoutPageType === 5),
          Validators.required
        )
      ],
    })
    this._unsubscribeAll = new Subject();
    // Set the defaults
    this.countdown = Constant.checkoutTimerCount;
    this.countdownMapping = {
      '=1': '# second',
      'other': '# seconds'
    };

    this.salesflatOrder = {

    };

  }
  selectedCouponName: string | null = null;
  searchTerm: string = '';
  getCoupon() {
    this.salesCartService.getSalesCart().subscribe(
      data => {

        this.couponList = (data['content'] || []).map((item: any) => {
          const name = item.name?.toUpperCase() || 'C';
          const firstLetter = name.charAt(0);

          // Generate a random pastel color for background
          const getRandomColor = () => {
            const colors = ['FF6347', '8A2BE2', '20B2AA', 'FF1493', 'FFD700', '00CED1', '32CD32', 'FF8C00', '1E90FF', 'DC143C'];
            return colors[Math.floor(Math.random() * colors.length)];
          };

          const bgColor = getRandomColor();

          return {
            name: name,
            iconUrl: `https://placehold.co/24x24/${bgColor}/FFF?text=${firstLetter}`,
            description: item.description || '',
            salesRuleCoupon: item.salesRuleCoupon
          };
        });

        console.log("the coupon List data is", this.couponList);


      },
      error => {
        console.error('Error fetching coupons:', error);
        this.snackBar.open('Failed to load coupons. Please try again.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }
  applySearchedCoupon(): void {
    const matchedCoupon = this.couponList.find(coupon =>
      coupon.name.toLowerCase() === this.searchTerm.trim().toLowerCase()
    );

    if (matchedCoupon) {
      this.selectedCouponName = matchedCoupon.name;
      //  this.defaultFunction(matchedCoupon.name); // You will implement this
    } else {
      this.selectedCouponName = null;
      alert('Invalid coupon code'); // or use your toast/snackbar
    }
  }
  applyCoupon(name: string, code: any): void {
    this.selectedCouponName = name;
    this.searchTerm = name;
    //this.defaultFunction(name);
    this.onCouponSelected(code);
    this.hideCouponScreen();
  }

  //For Phone Pe
  getPhonePeConfig() {
    this.configService.getConfigData().subscribe(
      (data) => {
        this.commonService.setCurrencyValue(data['currencyBase']);
        this.ccAvenueUrl = data['ccAvenueUrl'];
        this.accessCode = data['ccAvenueAccessCode'];
        this.merchantId = data['ccAvenueMerchantId'];
        this.Enckey = data['ccAvenueEncKey'];
        this.paypalLoad = false;
      },
      (error) => {
        this.accessCode = 'AVKE93KA88AK07EKKA';
        this.Enckey = '56B104EC14BE9C6A00D102C0B068C10B';
        this.merchantId = 'merchant_id';
        this.paypalLoad = false;
      }
    );
  }
  phonePeCheckout() {
    const redirectUrl = window.location.origin + '/pay';

    const orderClone = { ...this.salesflatOrder }; // deep clone if necessary
    delete orderClone['customerGender'];

    this.email = localStorage.getItem('authenticaterUserEmail');
    if (!this.email) {
      orderClone['customerId'] = 1;
      this.email = this.selectedAddres?.[0]?.lastName || 'guest@example.com';
      orderClone['cartId'] = localStorage.getItem(Constant['CART_ID']);
    }

    const encryptedOrder = this.ecryptService.encrypt(orderClone);

    const payload = {
      phone: this.selectedAddres?.[0]?.telephone,
      amount: (this.partialAmountEnabled == 1 &&
        this.partialPaymentControl?.value == 'Partial Payment')
        ? this.paritialPaymentAmountControl?.value * 100
        : (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * 100,
      order_cons: encryptedOrder,
      redirectUrl,
      callbackUrl: redirectUrl,
    };

    this.phonePeService.post(payload).subscribe(
      (res) => {
        const redirectUrl = res['redirectUrl'];
        window.location.href = redirectUrl;
        this.handlePhonePeCallback(res);
      },
      (err) => {
        this.snackBar.open('Unable to initiate payment. Please try again.', '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 3000,
        });
      }
    );
  }
  handlePhonePeCallback(response: any) {
    if (response['order_status'] === 'Success') {
      const paymentInfo = {
        tracking_id: response['tracking_id'],
        bank_ref_no: response['bank_ref_no'],
        payment_mode: response['payment_mode'],
        method: 'CCAvenue',
      };

      this.paymentObject = {
        salesPaymentTransaction: [{
          txn_id: response['tracking_id'],
          txn_type: 'customer',
          isClose: true,
        }],
        salesFlatOrderPayment: {
          method: 'CCAvenue',
          additionalInformation: JSON.stringify(paymentInfo),
        },
        paypalPaymentStatus: 'Successful',
      };

      this.paymentResponceCCAvenue(this.paymentObject);
    } else {
      this.snackBar.open('Payment failed. Please try again.', '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 3000,
      });
    }
  }


  //For Razor Pay
  loadRazorpayScript() {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      this.razorpayScriptLoaded = true;
    };
    script.onerror = (err) => {
      console.error('Failed to load Razorpay script', err);
    };
    document.head.appendChild(script);
  }

  getRazorpayConfig() {
    this.configService.getConfigData().subscribe(
      data => {
        this.commonService.setCurrencyValue(data['currencyBase']);
        this.razorKey = data['razorPayKey'];
        this.razorpayReady = true;
      },
      error => {
        this.razorKey = 'rzp_test_mGa2SfsXusZ9u'; // fallback key
        this.razorpayReady = true;
      }
    );
  }

  createRazorpayOrder() {
    if (!this.razorpayReady || !this.razorpayScriptLoaded) {
      this.snackBar.open('Payment not ready. Try again shortly.', '×', { duration: 3000 });
      return;
    }

    const amountToPay = (this.partialPaymentControl?.value === 'Partial Payment' && this.paritialPaymentEnabled == 1)
      ? this.paritialPaymentAmountControl?.value
      : this.grandTotal + this.consultationFees;

    const contact: any = this.contact;

    const options: any = {
      key: this.razorKey,
      amount: Math.round(amountToPay) * 100,
      currency: 'INR',
      name: 'YourCompany',
      description: 'Order Payment',
      prefill: {
        name: contact?.name || '',
        contact: contact?.contact || '',
        email: contact?.email || ''
      },
      notes: {
        address: 'Customer Address'
      },
      theme: {
        color: '#3399cc'
      },
      handler: (response: any) => {
        this.handleRazorpaySuccess(response, options, amountToPay);
      },
      modal: {
        escape: false,
        ondismiss: () => {
          this.snackBar.open('Payment cancelled by user.', '×', { duration: 3000 });
        }
      }
    };

    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }
  handleRazorpaySuccess(response: any, options: any, amountPaid: number) {
    const isPartial = this.partialPaymentControl?.value === 'Partial Payment' && this.paritialPaymentEnabled == 1;

    const paymentInfo = isPartial ? {
      razorpay_payment_id: response['razorpay_payment_id'],
      currency: options.currency,
      Partial_Payment: 'Yes',
      Partial_Paid_Amount: amountPaid
    } : {
      razorpay_payment_id: response['razorpay_payment_id'],
      currency: options.currency
    };

    this.additionData = JSON.stringify(paymentInfo);

    this.paymentObject = {
      salesPaymentTransaction: [{
        txn_id: response['razorpay_payment_id'],
        txn_type: 'customer',
        isClose: true
      }],
      salesFlatOrderPayment: {
        method: 'razor_pay',
        additionalInformation: this.additionData
      },
      paypalPaymentStatus: 'Successful'
    };

    // Emit or call function
    this.paymentResponceRazorPAy(this.paymentObject);
  }



  initializeForm() {
    this.cartFormGroup = this.formBuilder.group({
      entityId: [''],
      baseGrandTotal: [''],
      grandTotal: [''],
      subtotal: [''],
      subtotalWithDiscount: [''],
      operationType: [''],
      itemsCount: [''],
      customerId: ['', Validators.required],
      storeId: [''],
      converterDate: [''],
      isActive: [''],
      isVirtual: [''],
      isMultiShipping: [''],
      itemsQty: [''],
      origOrderId: [''],
      storeToBaseRate: [''],
      storeToQuoteRate: [''],
      baseCurrencyCode: [''],
      storeCurrencyCode: [''],
      quoteCurrencyCode: [''],
      checkoutMethod: [''],
      customerTaxClassId: [''],
      customerGroupId: [''],
      customerEmail: [''],
      customerPrefix: [''],
      customerFirstname: [''],
      customerMiddlename: [''],
      customerLastname: [''],
      customerSuffix: [''],
      customerDob: [''],
      customerNote: [''],
      customerNoteNotify: [''],
      customerIsGuest: [''],
      remoteIp: [''],
      appliedRuleIds: [''],
      reservedOrderId: [''],
      passwordHash: [''],
      couponCode: [''],
      globalCurrencyCode: [''],
      baseToGlobalRate: [''],
      baseToQuoteRate: [''],
      customerTaxvat: [''],
      customerGender: [''],
      baseSubtotal: [''],
      baseSubtotalWithDiscount: [''],
      isChanged: [''],
      triggerRecollect: [''],
      extShippingInfo: [''],
      ///Transient
      currencyCode: [''],
      taxAmount: [0.0],
      imageCustomize: [''],
      salesFlatQuoteItem: this.formBuilder.array([
        //this.cartItemForm()
      ])

    });
  }
  cartItemForm(): UntypedFormGroup {

    return this.formBuilder.group({
      itemId: ['', Validators.required],
      quoteId: ['', Validators.required],
      baseDiscountAmount: ['', Validators.required],
      baseHiddenTaxAmount: ['', Validators.required],
      basePrice: ['', Validators.required],
      basePriceInclTax: ['', [Validators.required, Validators.pattern("^[0-9]*$"),]],
      baseRowTotal: ['', Validators.required],
      price: ['', Validators.required],
      productType: ['', Validators.required],
      taxAmount: ['', [Validators.required, Validators.pattern("^[0-9]*$"),]],
      imageUrl: ['', Validators.required],
      image: ['', Validators.required],
      description: ['', Validators.required],
      rowTotal: ['', Validators.required],
      name: ['', Validators.required],
      qty: ['', Validators.required],
      productId: ['', Validators.required],
      operationType: ['', Validators.required],
      storeId: ['', Validators.required],
      isInStock: [''],
      isVirtual: [''],
      sku: [''],
      categoryId: [''],
      appliedRuleIds: [''],
      additionalData: [''],
      freeShipping: [''],
      isQtyDecimal: [''],
      noDiscount: [''],
      weight: [''],
      discountPercent: [''],
      discountAmount: [''],
      taxPercent: [''],
      baseTaxAmount: [''],
      rowTotalWithDiscount: [''],
      rowWeight: [''],
      priceInclTax: [''],
      rowTotalInclTax: [''],
      baseRowTotalInclTax: [''],
      hiddenTaxAmount: [''],
      weeeTaxDisPosition: [''],
      weeeTaxRowDisposition: [''],
      baseWeeeTaxDisposition: [''],
      baseWeeeTaxRowDisposition: [''],
      weeeTaxApplied: [''],
      weeeTaxAppliedAmount: [''],
      baseWeeeTaxAppliedAmount: [''],
      itemsCount: [''],
      currencyCode: [''],
      customerId: [''],
      remoteIp: [''],
      unit: [''],
      productCustomOption: [''],
      supplierLatitude: [''],
      supplierLongitude: [''],
      supplierId: [''],
      supplierName: [''],
      prescriptionRequired: [''],
      cgst: [''],
      sgst: [''],
      igst: [''],
      inclusiveTax: [''],
      stockInHand: new UntypedFormControl(0),
      subscriptionForm: this.subscriptionForm(),
      salesFlatQuoteItemOption: this.formBuilder.array([
        this.cartItemOptionForm()
      ]),
      renewalPeriod: [0],
      renewalPeriodType: [0],
      imageCustomize: [''],
      customizeImage: [''],
      message: [''],
      dateValue: [''],
      additionalInformation: [''],
      productImages: [''],
      productIncId: ['']
    });



  }

  subscriptionForm(): UntypedFormGroup {
    let control = this.formBuilder.group({
      subscriptionId: [''],
      userId: ['',],
      subscriptionType: ['',],
      startDate: ['',],
      endDate: [''],
      totalQuantity: ['',],
      operationType: [''],
      cartItemId: [''],
      orderItemId: [''],
      productId: [''],
      price: ['',],
      specialPrice: ['',],
      baseSubtotal: ['',],
      subtotal: ['',],
      totalQty: ['',],
      subscriptionOccurrences: this.formBuilder.array([
        this.SubscriptionOccurrencesForm()
      ]),
    });

    return control;
  }

  SubscriptionOccurrencesForm(): UntypedFormGroup {
    return this.formBuilder.group({
      subscriptionOccurrenceId: [''],
      subscriptionId: [''],
      occurrenceDate: [''],
      quantity: [''],
      isActive: [''],
      isDelivered: [''],
      deliveryPeopleId: [''],
      occurrenceDay: [''],
      totalDays: [''],

    });
  }
  cartItemOptionForm(): UntypedFormGroup {

    return this.formBuilder.group({
      additional: [''],
      additionalInfoGiven: [''],
      sku: [''],
      code: [''],
      optionId: [''],
      productId: [''],
      value: [''],
      index: [''],
      materialCost: [''],
      additionalCost: [''],
      imageCustomize: [''],
      customizeImage: [''],
      message: [''],
      dateValue: [''],
    });
  }
  editCartList(cartList: CartItem) {
    this.getTotalValue(cartList);
    if (cartList != null) {
      this.cartList = cartList;

      this.cartFormGroup.patchValue({
        entityId: cartList.entityId,
        baseGrandTotal: cartList.baseGrandTotal,
        grandTotal: cartList.grandTotal,
        subtotal: cartList.subtotal,
        subtotalWithDiscount: cartList.subtotalWithDiscount,
        customerId: cartList.customerId,
        operationType: cartList.operationType,
        itemsCount: cartList.itemsCount,

        storeId: cartList.storeId,
        converterDate: cartList.converterDate,
        isActive: cartList.isActive,
        isVirtual: cartList.isVirtual,
        isMultiShipping: cartList.isMultiShipping,
        itemsQty: cartList.itemsQty,
        origOrderId: cartList.origOrderId,
        storeToBaseRate: cartList.storeToBaseRate,
        storeToQuoteRate: cartList.storeToQuoteRate,
        baseCurrencyCode: cartList.baseCurrencyCode,
        storeCurrencyCode: cartList.storeCurrencyCode,
        quoteCurrencyCode: cartList.quoteCurrencyCode,
        checkoutMethod: cartList.checkoutMethod,
        customerTaxClassId: cartList.customerTaxClassId,
        customerGroupId: cartList.customerGroupId,
        customerEmail: cartList.customerEmail,
        customerPrefix: cartList.customerPrefix,
        customerFirstname: cartList.customerFirstname,
        customerMiddlename: cartList.customerMiddlename,
        customerLastname: cartList.customerLastname,
        customerSuffix: cartList.customerSuffix,
        customerDob: cartList.customerDob,
        customerNote: cartList.customerNote,
        customerNoteNotify: cartList.customerNoteNotify,
        customerIsGuest: cartList.customerIsGuest,
        remoteIp: cartList.remoteIp,
        appliedRuleIds: cartList.appliedRuleIds,
        reservedOrderId: cartList.reservedOrderId,
        passwordHash: cartList.passwordHash,
        couponCode: cartList.couponCode,
        globalCurrencyCode: cartList.globalCurrencyCode,
        baseToGlobalRate: cartList.baseToGlobalRate,
        baseToQuoteRate: cartList.baseToQuoteRate,
        customerTaxvat: cartList.customerTaxvat,
        customerGender: cartList.customerGender,
        baseSubtotal: cartList.baseSubtotal,
        baseSubtotalWithDiscount: cartList.baseSubtotalWithDiscount,
        isChanged: cartList.isChanged,
        triggerRecollect: cartList.triggerRecollect,
        extShippingInfo: cartList.extShippingInfo,
        ///Transient
        currencyCode: cartList.currencyCode,
        unit: cartList.unit,
        imageCustomize: cartList.imageCustomize,
        customizeImage: cartList.customizeImage,
        taxAmount: cartList.taxAmount == undefined ? 0.0 : cartList.taxAmount

      });



      if (cartList.salesFlatQuoteItem.length == 0) {
        localStorage.removeItem(Constant.CART_COUNT)
        this.cartServices.responseCache1 = new Map();
      }

      this.cartFormGroup.setControl('salesFlatQuoteItem', this.editCartItemList(cartList.salesFlatQuoteItem));
    }
    else {

      localStorage.removeItem(Constant.CART_COUNT)
      this.cartServices.responseCache1 = new Map();
      this.cartList = null;
    }
  }
  getTotalValue(i) {
    let value = i;
    this.getTotal(i);
  }
  editCartItemList(cartItemList: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    this.skuList = []; // Clear previous SKU list if any

    cartItemList.forEach(s => {
      if (s.prescriptionRequired == 1) {
        this.prescriptionRequired = true;
      }
      this.skuList.push(s.sku);

      formArray.push(this.formBuilder.group({
        itemId: s.itemId,
        quoteId: s.quoteId,
        baseDiscountAmount: s.baseDiscountAmount,
        baseHiddenTaxAmount: s.baseDiscountAmount,
        basePrice: s.basePrice,
        basePriceInclTax: s.basePriceInclTax,
        baseRowTotal: s.baseRowTotal,
        isInStock: s.isInStock,
        price: s.price,
        storeId: s.storeId,
        productType: s.productType,
        taxAmount: s.taxAmount,
        description: s.description,
        name: s.name,
        rowTotal: s.rowTotal,
        qty: s.qty,
        productId: s.productId,
        operationType: s.operationType,
        imageUrl: s.imageUrl,
        image: this.getImagetwo(s.imageUrl, s.imageCustomize, s.customizeImage, s.productImages),
        categoryId: s.categoryId,
        isVirtual: s.isVirtual,
        sku: s.sku,
        appliedRuleIds: s.appliedRuleIds,
        additionalData: s.additionalData,
        freeShipping: s.freeShipping,
        isQtyDecimal: s.isQtyDecimal,
        noDiscount: s.noDiscount,
        weight: s.weight,
        discountPercent: s.discountPercent,
        discountAmount: s.discountAmount,
        taxPercent: s.taxPercent,
        baseTaxAmount: s.baseTaxAmount,
        rowTotalWithDiscount: s.rowTotalWithDiscount,
        rowWeight: s.rowWeight,
        priceInclTax: s.priceInclTax,
        rowTotalInclTax: s.rowTotalInclTax,
        baseRowTotalInclTax: s.baseRowTotalInclTax,
        hiddenTaxAmount: s.hiddenTaxAmount,
        weeeTaxDisPosition: s.weeeTaxDisPosition,
        weeeTaxRowDisposition: s.weeeTaxRowDisposition,
        baseWeeeTaxDisposition: s.baseWeeeTaxDisposition,
        baseWeeeTaxRowDisposition: s.baseWeeeTaxRowDisposition,
        weeeTaxApplied: s.weeeTaxApplied,
        weeeTaxAppliedAmount: s.weeeTaxAppliedAmount,
        baseWeeeTaxAppliedAmount: s.baseWeeeTaxAppliedAmount,
        itemsCount: s.itemsCount,
        currencyCode: s.currencyCode,
        customerId: s.customerId,
        remoteIp: s.remoteIp,
        unit: s.unit,
        productCustomOption: s.productCustomOption,
        supplierLatitude: s.supplierLatitude,
        supplierLongitude: s.supplierLongitude,
        supplierId: s.supplierId,
        supplierName: s.supplierName,
        prescriptionRequired: s.prescriptionRequired,
        cgst: s.cgst,
        sgst: s.sgst,
        igst: s.igst,
        stockInHand: s.stockInHand == null ? 0 : s.stockInHand,
        inclusiveTax: s.inclusiveTax,
        renewalPeriod: s.renewalPeriod == null ? 0 : s.renewalPeriod,
        renewalPeriodType: s.renewalPeriodType == null ? 0 : s.renewalPeriodType,
        imageCustomize: s.imageCustomize,
        customizeImage: s.customizeImage,
        message: s.message,
        dateValue: s.dateValue,
        additionalInformation: s.additionalInformation,
        productImages: s.productImages,
        productIncId: s.productIncId,
        salesFlatQuoteItemOption: this.setValueSalesFlatQuoteItemOption(s.salesFlatQuoteItemOption || []),
        subChild: s.subChild && s.subChild.length > 0 ? this.editCartSubItemList(s.subChild) : this.formBuilder.array([]),
        subscription: s.subscription != null ? this.editsubscriptionList(s.subscription) : null,
      }));
    });
    return formArray;
  }
  editCartSubItemList(cartItemList: SalesFlatQuoteItem[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    cartItemList.forEach((s: any) => {
      if (s.prescriptionRequired == 1) {
        this.prescriptionRequired = true;
      }
      this.skuList.push(s.sku);

      formArray.push(this.formBuilder.group({
        itemId: s.itemId,
        quoteId: s.quoteId,
        baseDiscountAmount: s.baseDiscountAmount,
        baseHiddenTaxAmount: s.baseDiscountAmount,
        basePrice: s.basePrice,
        basePriceInclTax: s.basePriceInclTax,
        baseRowTotal: s.baseRowTotal,
        isInStock: s.isInStock,
        price: s.price,
        storeId: s.storeId,
        productType: s.productType,
        taxAmount: s.taxAmount,
        description: s.description,
        name: s.name,
        rowTotal: s.rowTotal,
        qty: s.qty,
        productId: s.productId,
        operationType: s.operationType,
        imageUrl: s.imageUrl,
        image: this.getImage(s.imageUrl, s.imageCustomize, s.customizeImage),
        categoryId: s.categoryId,
        isVirtual: s.isVirtual,
        sku: s.sku,
        appliedRuleIds: s.appliedRuleIds,
        additionalData: s.additionalData,
        freeShipping: s.freeShipping,
        isQtyDecimal: s.isQtyDecimal,
        noDiscount: s.noDiscount,
        weight: s.weight,
        discountPercent: s.discountPercent,
        discountAmount: s.discountAmount,
        taxPercent: s.taxPercent,
        baseTaxAmount: s.baseTaxAmount,
        rowTotalWithDiscount: s.rowTotalWithDiscount,
        rowWeight: s.rowWeight,
        priceInclTax: s.priceInclTax,
        rowTotalInclTax: s.rowTotalInclTax,
        baseRowTotalInclTax: s.baseRowTotalInclTax,
        hiddenTaxAmount: s.hiddenTaxAmount,
        weeeTaxDisPosition: s.weeeTaxDisPosition,
        weeeTaxRowDisposition: s.weeeTaxRowDisposition,
        baseWeeeTaxDisposition: s.baseWeeeTaxDisposition,
        baseWeeeTaxRowDisposition: s.baseWeeeTaxRowDisposition,
        weeeTaxApplied: s.weeeTaxApplied,
        weeeTaxAppliedAmount: s.weeeTaxAppliedAmount,
        baseWeeeTaxAppliedAmount: s.baseWeeeTaxAppliedAmount,
        itemsCount: s.itemsCount,
        currencyCode: s.currencyCode,
        customerId: s.customerId,
        remoteIp: s.remoteIp,
        unit: s.unit,
        productCustomOption: s.productCustomOption,
        supplierLatitude: s.supplierLatitude,
        supplierLongitude: s.supplierLongitude,
        supplierId: s.supplierId,
        supplierName: s.supplierName,
        prescriptionRequired: s.prescriptionRequired,
        cgst: s.cgst,
        sgst: s.sgst,
        igst: s.igst,
        stockInHand: s.stockInHand == null ? 0 : s.stockInHand,
        inclusiveTax: s.inclusiveTax,
        imageCustomize: s.imageCustomize,
        customizeImage: s.customizeImage,
        message: s.message,
        dateValue: s.dateValue,
      }));
    });
    return formArray;
  }
  editsubscriptionList(subcription: any): UntypedFormGroup {
    return this.formBuilder.group({
      subscriptionId: subcription.subscriptionId,
      userId: subcription.userId,
      subscriptionType: subcription.subscriptionType,
      startDate: subcription.startDate,
      endDate: subcription.endDate,
      totalQuantity: subcription.totalQuantity,
      cartItemId: subcription.cartItemId,
      orderItemId: subcription.orderItemId,
      productId: subcription.productId,
      price: subcription.price,
      specialPrice: subcription.specialPrice,
      baseSubtotal: subcription.baseSubtotal,
      subtotal: subcription.subtotal,
      totalQty: subcription.totalQty,
      subscriptionOccurrences: this.setValueSubscriptionOccurrencesForm(subcription.subscriptionOccurrences || [])
    });
  }
  setValueSubscriptionOccurrencesForm(subscriptionOccurrences: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    subscriptionOccurrences.forEach(occurrence => {
      formArray.push(this.formBuilder.group({
        subscriptionOccurrenceId: occurrence.subscriptionOccurrenceId,
        subscriptionId: occurrence.subscriptionId,
        occurrenceDate: occurrence.occurrenceDate,
        quantity: occurrence.quantity,
        isActive: occurrence.isActive,
        isDelivered: occurrence.isDelivered,
        deliveryPeopleId: occurrence.deliveryPeopleId,
        occurrenceDay: occurrence.occurrenceDay,
        totalDays: occurrence.totalDays,
      }));
    });
    return formArray;
  }
  setValueSalesFlatQuoteItemOption(salesFlatQuoteItemOption: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    salesFlatQuoteItemOption.forEach(option => {
      formArray.push(this.formBuilder.group({
        additional: option.additional,
        additionalInfoGiven: option.additionalInfoGiven,
        code: option.code,
        optionId: option.optionId,
        productId: option.productId,
        value: option.value,
        index: option.index,
        materialCost: option.materialCost,
        additionalCost: option.additionalCost,
        imageCustomize: option.imageCustomize,
        customizeImage: option.customizeImage
      }));
    });
    return formArray;
  }
  getImagetwo(imageUrl: any, imageCustomized: any, image: any, imagesarray: any): any {
    if (typeof imagesarray === 'string') {
      imagesarray = imagesarray
        .replace(/[\[\]]/g, '')
        .split(',')
        .map(item => item.trim().replace(/^'|'$/g, ''));
    }

    if (!Array.isArray(imagesarray) || imagesarray.length === 0) {
      return this.categoryPageImageLayout;
    }

    if (imageCustomized == 1) {
      return image;
    }

    if (imageUrl == 'null' || !imageUrl || imageUrl.trim() === '') {
      return this.serverPath + imagesarray[0];
    } else if (imageUrl.includes('http')) {
      return imageUrl;
    } else if (imageUrl.includes('medicineimages')) {
      let array = [];
      array = imageUrl.split('medicineimages');
      return environment.commonImageApiNew + 'medicineimages/' + array[1];
    } else if (imageUrl.includes('commonimages')) {
      let array = [];
      array = imageUrl.split('commonimages');
      return this.serverPath7 + 'commonimages/' + array[1];
    } else {
      return this.serverPath + imageUrl;
    }

  }
  getImage(imageUrl: any, imageCustomized: any, image: any): any {
    if (imageCustomized == 1) {
      return image;
    } else if (imageUrl == null) {
      return this.categoryPageImageLayout;
    } else if (imageUrl.includes('http')) {
      return imageUrl;
    } else if (imageUrl.includes('medicineimages')) {
      let array = [];
      array = imageUrl.split('medicineimages');
      return environment.commonImageApiNew + 'medicineimages/' + array[1];
    } else if (imageUrl.includes('commonimages')) {
      let array = [];
      array = imageUrl.split('commonimages');
      return this.serverPath7 + 'commonimages/' + array[1];
    } else {
      return this.serverPath + imageUrl;
    }
  }
  get salesFlatQuoteItems(): UntypedFormArray {
    return this.cartFormGroup.get('salesFlatQuoteItem') as UntypedFormArray;
  }
  get cartItemsList(): FormArray {
    return this.cartFormGroup.get('salesFlatQuoteItem') as FormArray;
  }
  getCartItem(index: number): UntypedFormGroup {
    return this.salesFlatQuoteItems.at(index) as UntypedFormGroup;
  }
  getSubChildItems(itemIndex: number): UntypedFormArray {
    const item = this.getCartItem(itemIndex);
    return item.get('subChild') as UntypedFormArray;
  }
  getSalesFlatQuoteItemOptions(itemIndex: number): UntypedFormArray {
    const item = this.getCartItem(itemIndex);
    return item.get('salesFlatQuoteItemOption') as UntypedFormArray;
  }



  //form Group for adress
  locationFound: boolean = false;


  getUserById(i) {


    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }

    if (this.authourized == null && this.guestLoginEnabled == "1") {

      let value = localStorage.getItem('address');

      if (value != null) {
        let result = this.commonService.getValueForDecryptedData(value);
        let address = JSON.parse(result)
        console.log(address);

        this.firstFormGroup.setControl('address', this.editAddress(address));
      } else {
        (<UntypedFormArray>this.firstFormGroup.get('address')).removeAt(0);

        let controls = 0
        if (controls == 0) {
          this.addAddress(controls)
        }

      }

    } else {
      let cache = i;
      this.userService.getUserById(i)
        .subscribe(
          (customer: any) => {
            this.editUser(customer);
            console.log("THe customer data is ", customer);

            if (this.distanceSelection == 1) {

              if (customer.address.length == 0) {
                if (!this.locationFound) {
                  this.visible = true;

                  this.addAddress(customer.address.length);
                }
              }


            }
            if (this.layout == 2) {

              this.radioChange(this.defalutValueAddress)
            }



          },


          (err: any) => {

          }
        );
    }
  }

  addAddress(i: number) {
    this.pincodeError = false;
    this.index = i;
    this.operation = "add";
    this.visible = false; // Hide address list, show form
    (<UntypedFormArray>this.firstFormGroup.get('address')).push(this.createAddressForm());
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }

    this.addGpsAddress();
  }
  addGpsAddress() {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(LocationComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        data: {
          page: 'address',
          fullDat: this.commonData
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getGpsAddress(result.data)

        } else if (result['event'] == 'close') {

          this.close()
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(LocationComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: 'address', fullDat: this.commonData }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getGpsAddress(result.data)

        } else if (result['event'] == 'close') {

          this.close()
        }
      });

    }

  }
  currentLat: any;
  currentLng: any;
  getGpsAddress(data) {

    this.selectedAddres = data;
    this.currentLat = data['latitude']
    this.currentLng = data['longitude']


    if (this.index == undefined) {
      this.index = 0;
    }
    this.firstFormGroup.value['address'][this.index].postCode = data['pincode'];
    this.firstFormGroup.value['address'][this.index].street = data['address'];
    this.firstFormGroup.value['address'][this.index].state = data['state'];
    // this.firstFormGroup.value['address'][this.index].city = data['city'];
    let indexCountry = this.countryList.findIndex(x => x.defaultName == data['country']);
    let value = this.countryList[indexCountry];
    this.firstFormGroup.value['address'][this.index].region = value.defaultName;
    this.firstFormGroup.value['address'][this.index].countryId = value.code;
    this.firstFormGroup.value['address'][this.index].regionId = value.regionId;
    this.firstFormGroup.value['address'][this.index].countryId = value.code;
    this.firstFormGroup.value['address'][this.index].regionId = value.regionId;

    this.firstFormGroup.value['address'][this.index].latitude = this.currentLat;
    this.firstFormGroup.value['address'][this.index].longitude = this.currentLng
    //pls fill the lat and lon here
    this.firstFormGroup.patchValue(this.firstFormGroup.value);
    this.getTotal(this.cartData);
    this.getCartItemsMain(this.cartData, 1);
    this.addressNotFilled = false;
  }
  editAddressForm(i: number, lat: string, lng: string) {
    if (this.distanceSelection == 1) {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('latitude', lat);
        localStorage.setItem('longitude', lng);
      }
      this.addGpsAddress();
      this.operation = "edit";
      this.index = i;
      this.visible = false; // Hide address list, show form
      this.pincodeError = false;
    } else {
      this.pincodeError = false;
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
      this.operation = "edit";
      this.index = i;
      this.visible = false; // Hide address list, show form
    }
  }
  countryTypeList: any;
  getCountryList() {
    this.commonService.getCountryList().subscribe(
      res => {
        this.countryList = res['content'];
        this.countryTypeList = res['content'];
        this.filteredcountryTypeList = this.countryTypeList;
      },
      error => {
        console.error("Error fetching country list:", error);
      });
  }


  cancelUserCreateForm(i: number) {
    this.index = i;
    this.visible = true; // Show address list, hide form
    if (this.operation != "edit" && this.operation != undefined) {
      (<UntypedFormArray>this.firstFormGroup.get('address')).removeAt(i);
    } else {
      this.ngOnInit(); // Re-initialize to revert changes if it was an edit and cancelled
    }
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }
  create: any;
  createCustomer() {
    const currentAddressControl = (this.firstFormGroup.controls['address'] as UntypedFormArray).controls[this.index];

    if (this.country == 'India' && currentAddressControl.get('postCode')?.value?.length < 6) {
      this.firstFormGroup.markAllAsTouched();
      currentAddressControl.get('postCode')?.setErrors({ maxlength: true });
      return;
    }

    if (this.firstFormGroup.valid) {
      if (!this.authourized && this.guestLoginEnabled == "1") {
        this.snackBar.open('Updated Successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        this.visible = true;

        let address = this.commonService.getValueForDecryptedDataAes(JSON.stringify(this.firstFormGroup.value.address));
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem("address", address);
        }
        this.updateaddress(this.firstFormGroup.value.address[this.defalutValueAddress]);
      } else {
        this.firstFormGroup.value.operationType = "New";
        this.firstFormGroup.value.dob = "2015-09-04 10:29:26"; // Example date
        this.firstFormGroup.value.gender = 1; // Example gender

        this.create = "Processing";

        this.userService.updateCustomer(this.firstFormGroup.value).subscribe(
          (response) => {
            this.snackBar.open('Updated Successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.visible = true;
            this.create = "Create";
            let cache = "update";
            this.getUserById(cache);
          },
          (err) => {
            console.error("Error updating customer:", err);
            this.create = "Create";
            // Handle error, show error message
          });
      }
    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  deleteAddress(i: number) {
    let addressId = this.firstFormGroup.value.address[i].entityId;

    (<UntypedFormArray>this.firstFormGroup.get('address')).removeAt(i);

    this.userService.deleteCustomer(addressId).subscribe(
      response => {
        this.snackBar.open('Address Deleted Successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        this.visible = true;
        let cache = "update";
        this.getUserById(cache);
      },
      error => {
        console.error("Error deleting address:", error);
        this.snackBar.open('Error deleting address', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  // This method determines if an address is deliverable based on various configurations
  updateaddress(value: any) {
    if (this.pinCodeSelection == 1) {
      this.pinCodeService.checkDuplicatePinCode(value.postCode).subscribe((response: any) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.onConfirmAddress.emit(value);
          this.pincodeError = false;
          if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
            // this.getAddressDeliverable.emit(true);
          }
        } else {
          this.onConfirmAddress.emit(undefined);
          //this.getAddressDeliverable.emit(false);
          this.pincodeError = true;
        }
      });
    } else if (this.warehouseBasedAllocation == 1) {
      let latitude = value['latitude'] || 0;
      let longitude = value['longitude'] || 0;

      this.warehouseService.getAllWarehouse(latitude, longitude, this.deliveryRange).subscribe(
        res => {
          let warehouseList: any[] = res as any[];
          if (warehouseList.length == 0) {
            //this.getAddressDeliverable.emit(false);
            this.pincodeError = true;
          } else {
            let smallestDistance = Infinity;
            let nearestLocation = null;
            let warehouseId: any;

            warehouseList.forEach(location => {
              if (location.latitude && location.longitude) {
                let distance = this.maps.getDistance(
                  value['latitude'], value['longitude'],
                  location.latitude, location.longitude
                );
                if (distance < smallestDistance) {
                  smallestDistance = distance;
                  nearestLocation = location;
                  warehouseId = location.warehousePosId;
                  this.destinationLat = location.latitude;
                  this.destinationLng = location.longitude;
                }
              }
            });

            if (nearestLocation) {
              if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem("whs", warehouseId.toString());
                localStorage.setItem("dstLat", this.destinationLat);
                localStorage.setItem("dstLon", this.destinationLng);
              }
              value['distance'] = smallestDistance;
              this.onConfirmAddress.emit(value);
              this.pincodeError = false;
              if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
                //this.getAddressDeliverable.emit(false); // This was 'false' in original, consider if it should be 'true' for deliverable
              }
            }
          }
        },
        error => { console.error("Error fetching warehouses:", error); }
      );
    } else if (this.distanceSelection == 1) {
      let distance = this.maps.getDistance(
        value['latitude'], value['longitude'],
        this.destinationLat, this.destinationLng
      );

      if (this.deliveryRange == 0 || this.deliveryRange > distance) {
        value['distance'] = distance;
        this.onConfirmAddress.emit(value);
        this.pincodeError = false;
        if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
          //  this.getAddressDeliverable.emit(true);
        }
      } else {
        this.pincodeError = true;
        if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
          // this.getAddressDeliverable.emit(false);
        }
      }
    } else {
      if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
        //  this.getAddressDeliverable.emit(true);
      }
      this.onConfirmAddress.emit(value);
      this.pincodeError = false;
    }
  }


  radioChange(i: number) {
    this.pincodeError = false;
    this.defalutValueAddress = i;
    // If you want to replicate userService.addressIndex, you'd need a similar Subject/BehaviorSubject
    // in your new component or a shared service. For now, we'll just set the local default.
    // this.userService.addressIndex.observers[0] = i;

    if (this.layout == 2) {
      this.getSelectedAddress(this.defalutValueAddress);
    }
  }

  // getSelectedAddress(i: number) {
  //   if (this.firstFormGroup.value.address[i] && this.firstFormGroup.value.address[i].postCode != '') {
  //     this.updateaddress(this.firstFormGroup.value.address[i]);
  //     // this.login('enable'); // Only if you have login logic tied to address selection
  //   }
  // }

  editUser(customer: User) {
    this.firstFormGroup.patchValue({
      entityId: customer.entityId,
      firstName: customer.firstName,
      lastName: customer.lastName,
      gender: customer.gender,
      operationType: customer.operationType,
      password: customer.password,
      email: customer.email,
      dob: customer.dob,
      telephone: customer.telephone,
      addressType: customer.addressType,
    });
    this.firstFormGroup.setControl('address', this.editAddress(customer.address));
  }

  spinnerCart: { [index: number]: boolean } = {};
  spinnerCartDecrease: { [index: number]: boolean } = {};


  public increment(item: FormGroup, type, index) {

    this.spinnerCart[index] = true;
    const qtyControl = item.get('qty');
    let qty = qtyControl?.value ?? 0;

    qty++;
    qtyControl?.setValue(qty);
    localStorage.removeItem(Constant.CART_COUNT)
    this.cartServices.responseCache1 = new Map();

    if (type == 'all') {
      this.changeQuantity(qty, index);
    } else {
      this.changeStockInHand(qty);
    }

    setTimeout(() => {
      this.spinnerCart[index] = false;
    }, 500);

    this.cartUpdated = true;

  }



  public decrementass(item: FormGroup, index) {

    this.spinnerCartDecrease[index] = true;

    const qtyControl = item.get('qty');
    let qty = qtyControl?.value;
    qty--;

    if (qty == 0) {
      this.deleteItemFromCart(item.value.itemId, index)
    } else {

      qtyControl?.setValue(qty);

      localStorage.removeItem(Constant.CART_COUNT)
      this.cartServices.responseCache1 = new Map();

      this.type = "all";
      if (this.type == 'all' || this.type == 'wish' || this.type == 'cartwish1' || this.type == 'cartwish2' || this.type == 'cartwish3') {
        this.changeQuantity(qty, index);
      } else {
        this.changeStockInHand(qty);
      }

      setTimeout(() => {
        this.spinnerCartDecrease[index] = false;
      }, 500);

      this.cartUpdated = true;

    }



  }
  public changeQuantity(value, index) {
    this.updateCart(value, index);
  }

  public changeStockInHand(value) {
    // this.onQuantityStockChange.emit(value);
  }
  public updateCart(value, i) {

    if (value != 'delete' && value != undefined) {
      this.cartFormGroup.value.itemsQty = value
      this.cartFormGroup.value.salesFlatQuoteItem[i].qty = value;
      this.cartFormGroup.value.operationType = "Change";
      this.cartFormGroup.value.salesFlatQuoteItem[i].operationType = "Change";
    }
    if (value == 'delete' && value != undefined) {
      this.firstFormGroup.value.operationType = "Delete";
    }
    this.complete(value, i)

  }

  complete(value, i) {

    this.cartService.addCartItem(this.cartFormGroup.value).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.updateToolbar();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

          let cache = "update"
          this.getCartItems(cache);
          localStorage.removeItem(Constant.CART_COUNT)
          this.cartServices.responseCache1 = new Map();

        }

        else {
          let cache = "update"
          this.getCartItems(cache);
          this.firstFormGroup.value.salesFlatQuoteItem[i].qty = value - 1;
          this.firstFormGroup.value.salesFlatQuoteItem[i].operationType = "NoChange";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          localStorage.removeItem(Constant.CART_COUNT)
          this.cartServices.responseCache1 = new Map();

        }

      },
      (err) => {

      });

  }
  updateToolbar() {
    this.cartService.cartItemCount().subscribe(
      (count) => {

        console.log("afsaf");


        this.cartCount = count;
        sessionStorage.setItem('CARTCOUNT', this.cartCount);
        // this.toolbarComponent.ngOnInit();
      }, (err) => { });

  }
  createUserForm() {
    this.firstFormGroup = this.formBuilder.group({
      entityId: [''],
      firstName: [''],
      lastName: [''],
      gender: [''],
      operationType: [''],
      password: [''],
      email: [''],
      dob: [''],
      telephone: [''],
      pinCodeSelection: [''],
      state: [''],
      address: this.formBuilder.array([
        // No initial address is added here. They will be added by editAddress or addAddress
      ])
    });
  }

  createAddressForm(): UntypedFormGroup {
    return this.formBuilder.group({
      entityId: [''],
      street: ['', [Validators.required]],
      firstName: ['', [Validators.required, noWhitespaceValidator]],
      'lastName': [
        null,
        Validators.compose([
          conditionalValidator(
            (() => this.guestLoginEnabled === "1"),
            Validators.required,
          ),
          conditionalValidator(
            (() => this.guestLoginEnabled === "1"),
            Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
          )
        ])
      ],
      telephone: ['', [Validators.required]],
      region: ['',],
      regionId: ['', Validators.required],
      state: [''],
      city: ['', [Validators.required, noWhitespaceValidator]],
      postCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      countryId: [''],
      company: [''],
      status: [''],
      latitude: [''],
      longitude: [''],
      distance: [''],
      addressType: ['', Validators.compose([
        conditionalValidator(
          (() => this.checkoutPageType === "3"),
          Validators.required,
        ),
      ])]
    });
  }

  editAddress(add: any[]): UntypedFormArray {
    let lat = isPlatformBrowser(this.platformId) ? localStorage.getItem('latitude') : null;
    let long = isPlatformBrowser(this.platformId) ? localStorage.getItem('longitude') : null;

    const formArray = new UntypedFormArray([]);
    let i = 0;
    add.forEach((s: any) => {
      if (this.distanceSelection == 1) {
        if (lat == s.latitude && long == s.longitude) {
          this.defalutValueAddress = i;
        }
      }
      formArray.push(this.formBuilder.group({
        entityId: s.entityId,
        street: s.street,
        region: s.region,
        firstName: s.firstName,
        lastName: s.lastName,
        state: s.state,
        city: s.city,
        postCode: s.postCode,
        addressType: s.addressType,
        company: s.company,
        status: s.status,
        telephone: s.telephone,
        countryId: s.countryId,
        regionId: parseInt(s.regionId as string), // Ensure regionId is a number if expected
        pinCodeSelection: this.pinCodeSelection,
        latitude: s.latitude,
        longitude: s.longitude,
      }));
      i++;
    });
    return formArray;
  }

  close(): void {

    if (this.cartUpdated) {

      let data = {

        url: 'none',
        whatsappNavigated: this.isWhatsApp,
        type: 5

      }


      this.dialogRef.close({ event: 'add', data: data })


    } else {

      this.dialogRef.close({ event: 'close' })
    }



  }

  selectCategory(categoryId: string): void {
    this.selectedCategory = categoryId;
  }

  getCategoryItems(): MenuItem[] {
    switch (this.selectedCategory) {
      case 'popular':
        return this.popularItems;
      case 'desserts':
        return this.dessertItems;
      case 'sides':
        return this.sideItems;
      default:
        return [];
    }
  }

  updateMainItemQuantity(change: number): void {
    if (this.mainItem.quantity !== undefined) {
      this.mainItem.quantity += change;
      if (this.mainItem.quantity < 0) {
        this.mainItem.quantity = 0;
      }
      this.calculateTotals();
    }
  }

  addToCart(item: MenuItem): void {
    const existingItem = this.cartItems.find(i => i.id === item.id);
    if (existingItem) {
      if (existingItem.quantity !== undefined) {
        existingItem.quantity++;
      }
    } else {
      this.cartItems.push({ ...item, quantity: 1 });
    }
    this.calculateTotals();
  }

  calculateTotals(): void {
    let currentItemTotal = 0;

    // Add main item total
    if (this.mainItem.quantity !== undefined) {
      currentItemTotal += this.mainItem.quantity * this.mainItem.price;
    }

    // Add items from "Complete Your Meal" section
    this.cartItems.forEach(item => {
      if (item.quantity !== undefined) {
        currentItemTotal += item.quantity * item.price;
      }
    });

    this.itemTotal = currentItemTotal;
    this.totalPay = this.itemTotal + this.deliveryFee + this.gstCharges;
  }

  showCouponScreen(): void {
    if (this.addressNotFilled == true) {
      this.snackBar.open('Please select an address', 'Close', {
        duration: 3000, // 3 seconds
        horizontalPosition: 'center',
        verticalPosition: 'bottom', // or 'top'
        panelClass: ['custom-snackbar'] // optional for styling
      });

    }
    else {
      this.currentView = 'coupon';

    }
  }

  hideCouponScreen(): void {
    this.currentView = 'cart';
  }

  showPaymentScreen(): void {
    if (this.addressNotFilled === true) {
      this.snackBar.open('Please select an address', 'Close', {
        duration: 3000, // 3 seconds
        horizontalPosition: 'center',
        verticalPosition: 'bottom', // or 'top'
        panelClass: ['custom-snackbar'] // optional for styling
      });

      // this.currentView = 'address';
    }
    else {
      this.currentView = 'payment';
    }

  }

  hidePaymentScreen(): void {
    this.currentView = 'cart';
  }

  showAddressScreen(): void {
    this.currentView = 'address';
  }

  hideAddressScreen(): void {
    this.currentView = 'cart';
  }

  selectAddress(address: any, index: any): void {
    this.selectedIndex = index;
    this.selectedAddressId = address.controls.entityId.value;
    if (this.selectedAddressId == '') {
      this.createCustomers();
    }

    this.updateSelectedLocation(address);
    this.hideAddressScreen();


    this.getSelectedAddress(address.value)

  }

  getSelectedAddress(i) {


    if (i == undefined) {
      this.paymentVisible = false;

    } else {
      i.entityId = 0;
      this.selectedAddres = [];
      this.checkOutAddress = i;
      this.selectedAddres.push(i);
      this.countryId = i.countryId;
      this.regionId = i.regionId;
      this.state = i.state;
      this.postCode = i.postCode;
      this.latitude = i.latitude;
      this.longitude = i.longitude
      this.distance = i.distance;
      this.index = 4;

    }


    this.getTotal(this.cartData)
    this.getCartItemsMain(this.cartData['salesFlatQuoteItem'], 1);
    this.loop = 1;

    this.paymentVisible = true;
  }

  createCustomers() {

    let authourized = this.userService.getAuthenticatedUser();

    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])

    if (guestLoginEnabled == "0" || authourized) {

      let name = localStorage.getItem("authenticaterUser") || 'Guest';

      let city = localStorage.getItem("city") || 'Chennai';

      let telephone = this.customerPhoneNo != null ? this.customerPhoneNo : localStorage.getItem("telephone");

      let addressArray = this.firstFormGroup.controls.address['controls'];

      addressArray.forEach(addrCtrl => {
        if (addrCtrl.controls.entityId.value === '') {
          addrCtrl.controls.firstName.setValue(name);
          addrCtrl.controls.city.setValue(city);
          addrCtrl.controls.telephone.setValue(telephone);
        }
      });

    } else {

      let name = localStorage.getItem("authenticaterUser") || 'Guest';

      let city = localStorage.getItem("city") || 'Chennai';

      let telephone = this.customerPhoneNo;

      let addressArray = this.firstFormGroup.controls.address['controls'];

      addressArray.forEach(addrCtrl => {
        if (addrCtrl.controls.entityId.value === '') {
          addrCtrl.controls.firstName.setValue(name);
          addrCtrl.controls.city.setValue(city);
          addrCtrl.controls.telephone.setValue(telephone);
        }
      });

    }

    this.firstFormGroup.controls.firstName.setValue(name);

    if (this.firstFormGroup.valid) {

      if (!this.authourized && this.guestLoginEnabled == "1") {
        this.snackBar.open('Updated SuccessFully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        this.visible = true;

        let address = this.commonService.getValueForDecryptedDataAes(JSON.stringify(this.firstFormGroup.value.address))
        localStorage.setItem("address", address)

        this.updateaddress(this.firstFormGroup.value.address[this.defalutValueAddress])
      } else {
        this.firstFormGroup.value.operationType = "New";
        this.firstFormGroup.value.dob = "2015-09-04 10:29:26";
        this.firstFormGroup.value.gender = 1;

        this.create = "Processing";

        this.userService.updateCustomer(this.firstFormGroup.value).subscribe(
          (response) => {

            this.snackBar.open('Updated SuccessFully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.visible = true;

            this.create = "Create";

            let cache = "update"
            this.getUserById(cache);

          },
          (err) => {

            this.create = "Create";

          });
      }

    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  @ViewChild('addressDialogPopup') addressDialogPopup: TemplateRef<any>;

  addressDialog() {
    let dialogRef = this.dialog.open(this.addressDialogPopup, {
      width: '550px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  updateSelectedLocation(address: any): void {
    const addressType = address?.controls?.addressType.value || "Home";
    const street = address?.controls?.street.value || "";
    this.selectedLocation = `${addressType} | ${street}`;
    this.addressNotFilled = false;
  }


  addNewAddress(): void {
    // In a real app, this would navigate to a new address form
    console.log('Navigate to add new address form');
    // For now, just hide the address screen
    this.hideAddressScreen();
  }
  toggleBillDetails(): void {
    this.isBillDetailsExpanded = !this.isBillDetailsExpanded;
  }

  calculateTotal(): void {
    const tip = parseFloat(this.tipControl.value);
    this.tip = tip;
  }

  checkPrescriptionProduct() {
    if (this.router.url.includes("type")) {
      this.prescriptionRequired = true;
    } else {
      this.cartServices.getPrescriptionStatus().subscribe(
        data => {

          if (data) {
            if (this.enableStorePickup == 1) {
              this.index = 1;
            } else {
              this.index = 2;
            }
            this.getAllMedicalDeliveryOption();
            this.prescriptionRequired = true;
          } else {
            this.prescriptionRequired = false;
          }


        }, error => {

        }
      );
    }

  }

  commentValidations = {
    'qrCodeReference': [
      { type: 'required', message: 'Please Enter Last 4 Digit UPI Transaction Id' },
    ],
  }

  getConfigData() {
    let data = this.configDataNew;
    localStorage.setItem(Constant['GUEST_LOGIN'], data['guestLogin'])
    this.commonService.setCurrencyValue(data['currencyBase']);
    this.pinCodeSelection = data['avaliablePincodes'];
    this.country = data['country'];
    this.destinationLat = data['supplierLatitude'];
    this.destinationLng = data['supplierLongitude'];
    this.shipmentVendor = data['shippingVendor'];
    this.configData = data;
    this.disableCoupoun = data['disableCoupoun'];
    this.shippingEnabled = data['shippingChargesApplied']
    this.showGst = data['showGstCartPage'];
    this.freeShippingAppliedAmount = data['freeShippingAppliedAmount'];
    this.ownerPostCode = data['zipPostCode'];
    this.ownerCountryID = data['country'];
    this.enableStorePickup = data['enableStorePickup'];
    this.cartPageLayout = data['cartPageLayout'];
    if (data['orderSuccessNavigated'] != undefined) {
      this.orderNaviatedUrl = data['orderSuccessNavigated']
    }

    if (data['orderUrl'] != undefined) {
      this.orderUrl = data['orderUrl']
    }


    if (this.cartPageLayout != null) {
      this.aboutService.getPageById(this.cartPageLayout).subscribe(
        (res) => {

          this.layoutype = res['type'];
          this.homePageBuilder = res['homePageBuilder'];
          this.init = true;
        }
      )
    }




    this.enableDeliveryTip = data['enableDeliveryTip'];

    this.enableDeliveryInstuction = data['enableDeliveryInformation'];


    this.checkoutTimerEnabled = data['checkoutTimerEnabled']
    this.checkoutTimerSeconds = data['checkoutTimerSeconds']
    this.calculateShippingRateBasedOnVendors = data['calculateShippingRateBasedOnVendors']
    this.storeName = data['storeName'];
    this.additionalDeliveryAmount = data['additionalDeliveryCharge'];
    this.additionalDeliveryChargeInPercent = data['additionalDeliveryChargeInPercent'];

    this.paritialPaymentEnabled = data['partialPayment'];

    this.paritialPaymentAmount = data['partialPaymentMinimumAmount'];

    this.paritialPaymentAmount = parseFloat(data['partialPaymentMinimumAmount']);

    this.paritialPaymentInfo = data['partialPaymentInfo'];

    this.calculateParitialAmountPercent = data['calculateParitialAmountPercent'];

    this.editParitialAmount = data['editParitialAmount'];

    this.paritialPaymentAmountControl.patchValue(this.paritialPaymentAmount.toFixed(2))

    this.conversionId = data['coversionTrackingIdGa'];

    this.distanceSelection = data['googleMapsEnabled'];

    this.codPaymentCharge = data['codPaymentCharge'];

    this.codPaymentMessage = data['codPaymentMessage'];

    this.additionalPaymentText = data['additionalPaymentText'];

    this.shippingAmountName = data['shippingAmountName'];

    this.taxName = data['taxName'];

    this.checkoutPageType = data['checkoutPageType'];


    this.shareChatId = data['shareChat'];

    this.priceDetailType = data['priceDetailType'];

    this.enableReferalCustomerDiscount = data['enableReferalCustomerDiscount'];

    this.printTimeInOrder = data['printTimeInOrder'];

    this.deliverySlotEnable = data['deliverySlotEnable'];

    this.orderDirectInvoiceEnable = data['orderDirectInvoiceEnable'];

    this.deliverySlotTiming = data['deliverySlotTiming'];

    this.deliverySlotPeriod = data['deliverySlotPeriod']

    if (data['warehouseBasedAllocation'] != undefined) {
      this.warehouseBasedAllocation = data['warehouseBasedAllocation'] == null ? 0 : data['warehouseBasedAllocation'];
    }
    if (this.warehouseBasedAllocation == 1) {
      let dstLat = localStorage.getItem("dstLat");
      let dstLong = localStorage.getItem("dstLon");

      if (dstLat != null && dstLong != null) {
        this.destinationLat = dstLat;
        this.destinationLng = dstLong;
      }
    }

    this.distanceSelection = data['googleMapsEnabled'];
    this.deliveryRange = data['deliveryRange'];
    this.checkoutPageType = data['checkoutPageType'];
    this.commonData = data;


    this.vendorEnabled = data['vendorEnabled'];
    if (this.checkoutTimerEnabled == 1) {
      this.countdown = this.checkoutTimerSeconds;
      this.startTimer();
    }

    this.deliveryTipAmount = data['deliveryTipAmount'];

    this.tipControl.patchValue(this.deliveryTipAmount)


    if (this.enableDeliveryTip == 1) {
      this.calculateTotal();
    }

    if (this.enableStorePickup == 1) {
      this.index = 1;
    } else if (this.prescriptionRequired) {
      this.index = 2;
    } else {
      this.index = 3;
    }

  }



  startTimer() {

    const duration = this.countdown;

    // Redirect after the countdown
    interval(1000)
      .pipe(
        take(duration),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        this.countdown--;
      },
        () => {
        },
        () => {
          if (this.countdown == 0) {
            this.router.navigate(['/cart'])
            this.snackBar.open("User session has been expired", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        }
      );
  }

  /**
 * On destroy
 */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  spinner = false;
  getCartItems(i) {
    //let cache = i;


    let page = this.router.url;
    let cache = i;
    let authourized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    if (authourized || guestLoginEnabled == "1") {

      this.spinner = true;
      this.cartService.getCartItemByUserId(cache, page).subscribe(
        (response) => {

          this.spinner = false;
          this.cartData = response;
          this.editCartList(response);


        },
        (err) => { });


    } else {
      this.snackBar.open("Please Login To Continue", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });

    }
  }
  getCartItemsMain(i, j) {
    let code = "paritialPaymentAmountControl"
    let value = this[code].value;
    this.salesFlatOrderItem = i;

    if (this.checkoutPageType == 1 || this.checkoutPageType == 7) {
      if (value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
        if (value < this.paritialPaymentAmount) {

          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }

        } else {
          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else if (this.paritialPaymentAmount < value && value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue(value.toFixed(2));
          }
          else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }
        }

      } else {
        if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
          this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
        } else {
          this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
        }

      }

      if (this.disableCoupoun == 0) {

        if (this.paritialPaymentEnabled == 1) {
          if (this.paritialPaymentEnabled == 1) {

            if (this.calculateParitialAmountPercent == 1) {

              let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
              this.paritialPaymentAmountControl.patchValue(value);
            } else {

              let value = this.paritialPaymentAmount;
              if (value > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
                this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
              }
            }
            this.index = 6;
          }
          this.index = 6;
        }
        else if (this.enableDeliveryTip == 1) {
          this.index = 7;

        } else if (this.enableDeliveryInstuction == 1) {
          this.index = 8;

        }
        else if (this.deliverySlotEnable == 1) {
          this.index = 9;

        }

        else {
          this.index = 10;
          this.formPaymentData()
          this.generateQr();

        }
      } else {
        this.index = 5;
      }
    }
    else if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {

      if (this.discountEnabled) {
        this.removeCoupon()
      }
      if (this.checkoutPageType == 2 || this.checkoutPageType == 3) {
        if (value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
          if (value < this.paritialPaymentAmount) {

            if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
            } else {
              this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
            }

          } else {
            if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
            } else if (this.paritialPaymentAmount < value && value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue(value.toFixed(2));
            }
            else {
              this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
            }
          }

        } else {
          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }

        }

        if (this.disableCoupoun == 0) {

          if (this.paritialPaymentEnabled == 1) {
            if (this.paritialPaymentEnabled == 1) {

              if (this.calculateParitialAmountPercent == 1) {

                let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
                this.paritialPaymentAmountControl.patchValue(value);
              } else {

                let value = this.paritialPaymentAmount;
                if (value > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
                  this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
                }
              }
              this.index = 6;
            }
            this.index = 6;
          }

        }
        this.formPaymentData()
        this.generateQr();
        this.index = 8;


      } else {
        this.index = 5;
      }

    }
    else if (this.checkoutPageType == 5) {

      if (this.discountEnabled) {
        this.removeCoupon()
      }
      if (this.checkoutPageType == 5) {
        if (value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
          if (value < this.paritialPaymentAmount) {

            if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
            } else {
              this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
            }

          } else {
            if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
            } else if (this.paritialPaymentAmount < value && value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
              this.paritialPaymentAmountControl.patchValue(value.toFixed(2));
            }
            else {
              this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
            }
          }

        } else {
          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }

        }

        if (this.disableCoupoun == 0) {

          if (this.paritialPaymentEnabled == 1) {
            if (this.paritialPaymentEnabled == 1) {

              if (this.calculateParitialAmountPercent == 1) {

                let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
                this.paritialPaymentAmountControl.patchValue(value);
              } else {

                let value = this.paritialPaymentAmount;
                if (value > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
                  this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
                }
              }
              this.index = 6;
            }
            this.index = 6;
          }

        }
        this.formPaymentData()
        this.generateQr();
        this.index = 8;


      } else {
        this.index = 5;
      }

    }

    if (this.enableReferalCustomerDiscount == 1) {
      let refId = sessionStorage.getItem(Constant.REFERAL_ID);
      let refProductId = sessionStorage.getItem(Constant.REFERRED_PRODUCT_ID);
      if (refId != null) {

        this.applyCouponCode(2);

      }
    }

  }

  salesFlatOrderAddress: any = [];



  // getSelectedAddress(i, j) {

  //   console.log(i);

  //   if (i == undefined) {
  //     this.paymentVisible = false;

  //   } else {
  //     i.entityId = 0;
  //     this.selectedAddres = [];
  //     this.checkOutAddress = i;
  //     this.selectedAddres.push(i);
  //     this.countryId = i.countryId;
  //     this.regionId = i.regionId;
  //     this.state = i.state;
  //     this.postCode = i.postCode;
  //     this.latitude = i.latitude;
  //     this.longitude = i.longitude
  //     this.distance = i.distance;
  //     this.index = 4;

  //     if ((this.checkoutPageType == 2 || this.checkoutPageType == 3) && this.loop > 0) {

  //       this.getTotal(this.cartData)
  //       this.getCartItems(this.cartData, 1);
  //     }

  //     if (this.checkoutPageType == 5 && this.loop > 0) {

  //       this.getTotal(this.cartData)
  //       this.getCartItems(this.cartData, 1);
  //     }
  //     this.paymentVisible = true;
  //   }




  // }

  getSelectedWarehouseAddress(i) {
    this.selectedAddres = [];
    this.checkOutAddress = i;

    i.firstName = i.name;
    i.lastName = " ";
    this.selectedAddres.push(i);
    this.countryId = i.countryId;
    this.regionId = i.regionId
    this.postCode = i.postCode;
    this.index = 4;
  }

  enablePanmentMode: boolean = false;


  handleAddressLengthChange(length: number) {

    if (length > 1) {
      this.enablePanmentMode = true;
    }

  }

  fetchCustomerData(i) {

    this.customerData = i
  }
  get isCartEmpty(): boolean {
    return !this.salesFlatOrderItem || this.salesFlatOrderItem.length === 0;
  }

  getTotal(event): void {
    console.log("the event ", event);


    // console.log(event.salesFlatOrderItem, "sasf");
    console.log(event, "sasf");
    console.log(event.baseGrandTotal - event.grandTotal, "saving");
    let value = event;
    if (this.loop == 0) {
      this.cartData = { ...value };
    }



    this.taxAmount = event['taxAmount']
    this.BaseGrandTotal = event['baseGrandTotal']
    this.GrandTotal = event['grandTotal']
    this.saving = event.baseGrandTotal - event.grandTotal;
    let authourized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
    let userName = null;
    if (guestLoginEnabled == "0" || authourized) {
      userName = this.userService.getAuthenticatedUserEmail();
    } else {


      if (this.userNameEnabled && this.selectedAddres[0] != undefined) {
        userName = this.selectedAddres[0].firstName
      } else {
        userName = "Not-Selected"
      }

    }

    if (this.checkoutPageType == 2 || this.checkoutPageType == 3 || this.checkoutPageType == 4 || this.checkoutPageType == 5) {

      this.userNameEnabled = true;
    }



    let object = {}
    if (isNumeric(userName)) {
      object = {
        "name": this.userNameEnabled ? this.selectedAddres[0].firstName : "Not-Selected",
        "contact": userName,


      }

    } else {


      if (this.enableStorePickup == 0) {
        object = {
          "name": this.userNameEnabled ? this.selectedAddres[0]?.firstName : "Not-Selected",
          "contact": this.userNameEnabled ? this.selectedAddres[0]?.telephone : "Not-Selected",
          "email": userName,

        }
      } else {
        if (guestLoginEnabled == "0" || authourized) {
          object = {
            "name": this.userNameEnabled ? this.customerData?.firstName : "Not-Selected",
            "contact": this.userNameEnabled ? this.customerData?.telephone : "Not-Selected",
            "email": userName,

          }
        } else {
          if (this.deliveryOptionControl.value != 'Pick Up From Store') {
            object = {
              "name": this.userNameEnabled ? this.selectedAddres[0].firstName : "Not-Selected",
              "contact": this.userNameEnabled ? this.selectedAddres[0]['telephone'] : "Not-Selected",
              "email": userName,

            }
          } else {
            object = {
              "name": null,
              "contact": null,
              "email": null,

            }
          }

        }

      }


      this.contact = object;

      this.paymentOptions = []

      this.totalWeigth = 0;

      if (!this.userNameEnabled) {
        this.mrp = event.baseSubtotal;
        this.grandTotalWithoutShippingCharge = event.grandTotal;
        this.delieveryCharge = 0.0;
        this.grandTotal = event.grandTotal;
      }
      if (this.calculateShippingRateBasedOnVendors == 0) {
        this.prescriptionRequired = false;
        event['salesFlatQuoteItem'].forEach(element => {
          this.totalWeigth = this.totalWeigth + element['rowWeight']
          if (!this.prescriptionRequired && element['prescriptionRequired'] == 1) {

            this.prescriptionRequired = true;

          }
        });
        this.defalutValue = 0;

        if (this.deliveryOptionControl.value == 'Pick Up From Store') {
          this.mrp = value.baseSubtotal;
          this.grandTotalWithoutShippingCharge = value.grandTotal;
          this.delieveryCharge = 0.0;
          this.codPaymentCharge = 0.0;
          this.grandTotal = value.grandTotal;
        }
        else if (this.countryId != 'AE') {

          if (this.shippingEnabled == 1 && this.deliveryOptionControl.value
            != 'Pick Up From Store') {


            this.shippingRate(this.totalWeigth,
              this.countryId, event.grandTotal,
              this.shipmentVendor, this.ownerPostCode,
              this.ownerCountryID, 0, 0, event, 0, 0)

          } else {
            let charge = 0.0;
            charge = this.calculateAdditionalShippingAmount(this.delieveryCharge, event);
            this.mrp = value.baseSubtotal;
            this.grandTotalWithoutShippingCharge = value.grandTotal;


            this.delieveryCharge = 0.0;
            this.delieveryCharge = parseFloat(this.delieveryCharge + charge);
            this.grandTotal = value.grandTotal + this.delieveryCharge;
          }
        }
        else {
          this.shippingRate(this.totalWeigth, this.countryId, event.grandTotal, this.shipmentVendor, this.ownerPostCode, this.ownerCountryID, 0, 0, event, 0, 0)
        }
        this.salesflatOrder = value;

      } else {

        if (this.shippingEnabled == 1 && this.deliveryOptionControl.value != 'Pick Up From Store') {

          let size = value['salesFlatQuoteItem'].length - 1;
          this.loopEnabled = true;
          let quoteItem = value;
          this.prescriptionRequired = false;
          this.totalWeigth = 0.0;
          value['salesFlatQuoteItem'].forEach((element, index) => {

            this.totalWeigth = this.totalWeigth + element['rowWeight']
            if (!this.prescriptionRequired && element['prescriptionRequired']) {

              this.prescriptionRequired = true;
            }

            if (size == index) {
              this.loopEnabled = false;

            }




            this.shippingRate(element['rowWeight'], this.countryId, value.grandTotal,
              this.shipmentVendor, element['supplierPincode'],
              element['supplierCountryId'], 1, index, value, size, index)


          });
        } else if (this.deliveryOptionControl.value == 'Pick Up From Store') {
          this.mrp = value.baseSubtotal;
          this.grandTotalWithoutShippingCharge = value.grandTotal;
          this.delieveryCharge = 0.0;
          this.grandTotal = value.grandTotal;
          this.salesflatOrder = value;
        }
        else {

          let charge = 0.0;
          charge = this.calculateAdditionalShippingAmount(this.delieveryCharge, value);
          this.grandTotalWithoutShippingCharge = value.grandTotal;
          this.delieveryCharge = this.delieveryCharge + charge;
          this.grandTotal = value.grandTotal + charge;

          value['calculateShippingRateBasedOnVendors'] = this.calculateShippingRateBasedOnVendors;
        }


      }

      if (!this.prescriptionRequired) {
        this.consultationFees = 0.0
        this.medicalDeliveryOptionControl.reset();
        this.deliveryOptionMedicalObject.reset();
      }
    }

    this.salesflatOrder = value;
    let value1: any = localStorage.getItem('currency');
    this.pixelService.track('InitiateCheckout', {
      content_ids: this.skuList,  // Item SKUs
      value: this.grandTotal,                         // Value of all items
      currency: value1                   // Currency of the value
    });


  }


  shippingRate(totalWeigth: any, countryId: any, grandTotal, vendor, ownerPostCode, ownerCountryID, type, index, event, quoteItemTotalIndex, currentIndex) {

    let calucalte = true;
    if (this.freeShippingAppliedAmount == 0.0) {
      calucalte = true;
    } else if (this.freeShippingAppliedAmount <= grandTotal) {
      calucalte = false;
    } else {
      calucalte = true;
    }



    if (totalWeigth > 0 && calucalte) {


      if (ownerPostCode == null) {
        ownerPostCode = this.ownerPostCode;
      }
      let object = {};
      if (this.distanceSelection == 0) {
        object = {
          "weight": totalWeigth,
          "countryId": countryId,
          "deliveryPostCode": this.postCode,
          "vendor": vendor,
          "clientCountryId": ownerCountryID,
          "postcode": ownerPostCode,
          "type": 1
        }
      } else {
        object = {
          "weight": totalWeigth,
          "countryId": countryId,
          "deliveryPostCode": this.distance,
          "vendor": vendor,
          "clientCountryId": ownerCountryID,
          "postcode": ownerPostCode,
          "latitude": this.latitude,
          "longitude": this.longitude,
          "type": 2
        }

      }

      this.shippingRateService.getShippingRate(object).subscribe(
        (response) => {

          if (type == 0) {



            this.delieveryCharge = 0.0;
            this.grandTotalWithoutShippingCharge = grandTotal;
            this.delieveryCharge = response;
            let charge = this.calculateAdditionalShippingAmount(this.delieveryCharge, event);
            this.delieveryCharge = response + charge;
            this.grandTotal = grandTotal + response + charge;
            event['calculateShippingRateBasedOnVendors'] = this.calculateShippingRateBasedOnVendors;
          } else {
            let totalCharge;
            if (index == 0) {
              this.delieveryCharge = 0.0;
              totalCharge = 0.0;
            }


            event['salesFlatQuoteItem'][currentIndex]['shippingAmount'] = response
            this.grandTotalWithoutShippingCharge = grandTotal;
            this.delieveryCharge = this.delieveryCharge + response;

            this.grandTotal = grandTotal + this.delieveryCharge;
            event['calculateShippingRateBasedOnVendors'] = this.calculateShippingRateBasedOnVendors;

            if (quoteItemTotalIndex == currentIndex) {
              let charge = this.calculateAdditionalShippingAmount(this.delieveryCharge, event);
              this.delieveryCharge = this.delieveryCharge + charge;

              this.grandTotal = grandTotal + this.delieveryCharge;
              this.salesflatOrder = event;
            }




            // this.salesflatOrder['salesFlatOrderItem'][index]['supplierLatitude']
            // this.salesflatOrder['salesFlatOrderItem'][index]['supplierLongitude']
            // this.salesflatOrder['salesFlatOrderItem'][index]['supplierId']
            // this.salesflatOrder['salesFlatOrderItem'][index]['supplierName']

          }


        },
        error => {
        }
      )


    } else {

      this.grandTotalWithoutShippingCharge = grandTotal;
      this.delieveryCharge = 0.0;
      this.grandTotal = grandTotal;

    }
  }

  calculateAdditionalShippingAmount(deliveryCharge, event) {

    let totalCharge = 0.0;
    if (this.additionalDeliveryAmount > 0) {

      if (this.additionalDeliveryChargeInPercent == 1) {

        totalCharge = (this.additionalDeliveryAmount / 100) * this.delieveryCharge;

        event['additionalDeliveryAmount'] = totalCharge;


      } else {

        totalCharge = this.additionalDeliveryAmount;



        event['additionalDeliveryAmount'] = totalCharge;
      }

    }

    return totalCharge;

  }

  public placeOrder() {





    this.formOrderJson();



    if (this.orderDirectInvoiceEnable == 1) {

      if (this.salesflatOrder.salesFlatInvoice.hasOwnProperty('salesFlatInvoice')) {
        delete this.salesflatOrder.salesFlatInvoice.salesFlatInvoice;
      }

    }


    this.loaderService.show();
    this.btnLabeltxt = "Processing";
    this.salesflatOrder['vendorEnabled'] = this.vendorEnabled;
    this.checkOut.placeOrder(this.salesflatOrder,
      this.conversionId, this.skuList, this.shareChatId).subscribe(
        (response) => {

          console.log("orders", response);


          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            let authourized = this.userService.getAuthenticatedUser();
            let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN'])
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            sessionStorage.setItem('CARTCOUNT', "0");
            localStorage.removeItem(Constant['CART_ID']);
            localStorage.removeItem(Constant.CART_COUNT)
            this.cartServices.responseCache1 = new Map();
            this.cartServices.getCount();
            this.userService.getCourseValuesNew();
            sessionStorage.removeItem(Constant.REFERAL_ID);
            sessionStorage.removeItem(Constant.REFERRED_PRODUCT_ID)

            this.loaderService.hide();



            if (authourized || guestLoginEnabled == "0") {

              if (this.isWhatsApp == true) {
                let phoneNumber = this.WhatsAppPhoneNumber.replace(/\D/g, "");

                let url = `https://wa.me/${encodeURIComponent(phoneNumber)}`;


                let data = {

                  url: url,
                  whatsappNavigated: this.isWhatsApp,
                  type: 1

                }


                this.dialogRef.close({ event: 'add', data: data })

                return
              } else if (this.orderNaviatedUrl == 1) {


                let data = {

                  url: this.orderUrl,
                  whatsappNavigated: this.isWhatsApp,
                  type: 2

                }
                const orderId = response['data'];

                let value = this.ecryptService.encryptionAES(JSON.stringify(orderId));

                localStorage.setItem("orderItem", value)

                this.dialogRef.close({ event: 'add', data: data })

              }
              else {
                if (response['data']['salesFlatOrderItem'][0].productType.includes('Variants Subscription')) {

                  let data = {

                    url: '/myCourse',
                    whatsappNavigated: this.isWhatsApp,
                    type: 2

                  }

                  this.dialogRef.close({ event: 'add', data: data })

                }
                else if (response['data']['salesFlatOrderItem'][0].productType.includes('Course')) {

                  let data = {

                    url: '/myCourse',
                    whatsappNavigated: this.isWhatsApp,
                    type: 2

                  }

                  this.dialogRef.close({ event: 'add', data: data })
                }
                else {

                  let data = {

                    url: '/orders',
                    whatsappNavigated: this.isWhatsApp,
                    type: 2

                  }

                  this.dialogRef.close({ event: 'add', data: data })

                }
              }

            } else {
              if (this.isWhatsApp == true) {
                let phoneNumber = this.WhatsAppPhoneNumber.replace(/\D/g, "");


                let url = `https://wa.me/${phoneNumber}`;


                let data = {

                  url: url,
                  whatsappNavigated: this.isWhatsApp,
                  type: 1

                }
                this.dialogRef.close({ event: 'add', data: data })
                return
              }

              else {

                let data = {

                  url: '/order/',
                  whatsappNavigated: this.isWhatsApp,
                  type: 3,
                  orderId: response['data']['entityId']

                }


                this.dialogRef.close({ event: 'add', data: data })
              }

            }

          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => { });
  }


  formOrderJson() {
    if (this.prescriptionRequired) {
      this.salesflatOrder['productTypeMedical'] = 1;
      this.salesflatOrder['prescriptionObject'] = JSON.stringify(this.deliveryOptionMedicalObject.value);

      if (this.medicalDeliveryOptionControl.value == 1) {
        let prescriptionList = [];
        this.mediaGallery.forEach(element => {
          let object = {
            value: element['fileName'].substring(1),
            customerId: this.salesflatOrder.customerId
          };
          prescriptionList.push(object);
        });
        this.salesflatOrder['prescriptionAttached'] = 1;
        this.salesflatOrder['salesFlatOrderPrescription'] = prescriptionList;
      } else {
        this.salesflatOrder['prescriptionAttached'] = 0;
      }
    }

    let refId = sessionStorage.getItem(Constant.REFERAL_ID);
    let refProductId = sessionStorage.getItem(Constant.REFERRED_PRODUCT_ID);

    if (refId != null) {
      this.salesflatOrder['referalId'] = refId;
      if (refProductId != null) {
        this.salesflatOrder['referalProductId'] = refProductId;
      }
    }

    if (this.payment === 'Cod') {
      this.salesFlatOrderPayment = {
        method: 'Cash On Delivery',
      };

      this.salesflatOrder['codCharges'] = this.codPaymentCharge;
      this.salesflatOrder['salesFlatOrderPayment'] = this.salesFlatOrderPayment;
      this.salesflatOrder['status'] = 'Pending';
      this.salesflatOrder['totalPaid'] = 0.0;
      this.salesflatOrder['baseTotalPaid'] = 0.0;
      this.salesflatOrder['remainingBalance'] = this.grandTotal + this.codPaymentCharge + this.consultationFees + this.getValidTip(this.tip);
      this.salesflatOrder['partialPaidAmount'] = 0.0;

    } else if (this.partialPaymentControl.value === 'Partial Payment' && this.paritialPaymentEnabled === 1) {
      this.salesflatOrder['status'] = 'Processing';
      this.salesflatOrder['totalPaid'] = this.paritialPaymentAmountControl.value;
      this.salesflatOrder['remainingBalance'] = this.salesflatOrder['grandTotal'] - this.paritialPaymentAmountControl.value + this.consultationFees + this.getValidTip(this.tip);
      this.salesflatOrder['partialPaid'] = 1;
      this.salesflatOrder['partialPaidAmount'] = this.paritialPaymentAmountControl.value;

    } else {
      this.salesflatOrder['status'] = 'Processing';
      this.salesflatOrder['totalPaid'] = this.grandTotal + this.consultationFees + this.getValidTip(this.tip);
      this.salesflatOrder['baseTotalPaid'] = this.salesflatOrder['baseGrandTotal'] + this.delieveryCharge;
      this.salesflatOrder['remainingBalance'] = 0.0;
      this.salesflatOrder['partialPaidAmount'] = 0.0;
    }

    if (this.discountEnabled) {
      this.salesflatOrder['couponCode'] = this.couponResult['couponCode'];
      this.salesflatOrder['couponRuleName'] = this.couponResult['couponRuleName'];
      this.salesflatOrder['discountAmount'] = this.couponResult['discountAmt'];
      this.salesflatOrder['discountPercent'] = 0.0;
      this.salesflatOrder['maxDiscountAmout'] = this.couponResult['maxDiscountAmout'] > 0;
    } else {
      this.salesflatOrder['couponCode'] = null;
      this.salesflatOrder['couponRuleName'] = null;
      this.salesflatOrder['discountAmount'] = 0.0;
      this.salesflatOrder['baseDiscountAmount'] = 0.0;
      this.salesflatOrder['discountPercent'] = 0.0;
      this.salesflatOrder['maxDiscountAmout'] = false;
    }

    this.salesFlatOrderItemOption = [];

    delete this.salesflatOrder['salesFlatQuoteAddress'];
    delete this.salesflatOrder['coreStore'];

    this.salesflatOrder.subtotal = this.grandTotalWithoutShippingCharge;
    this.salesflatOrder.salesFlatQuoteItemOption = this.salesFlatOrderItemOption;
    this.salesflatOrder['deliveryOption'] = this.deliveryOptionControl.value;
    this.salesflatOrder['grandTotal'] = this.grandTotal + this.codPaymentCharge + this.consultationFees + this.getValidTip(this.tip);
    this.salesflatOrder['additionalMedicalharge'] = this.consultationFees;
    this.salesflatOrder['tip'] = this.tip;
    this.salesflatOrder['orderAdditionalInfo'] = this.deliveryAdditionInfo.value;
    this.salesflatOrder['orderDeliveryTime'] = this.orderDeliveryTime;
    this.salesflatOrder['orderDeliveryType'] = this.deliveryType.value;
    this.salesflatOrder['printDateTime'] = this.newTime;
    this.salesflatOrder['warehouseLatitude'] = this.warehouseLatitude;
    this.salesflatOrder['warehouseLongitude'] = this.warehouseLongitude;

    let currency = this.currencyConversionService.getCountryCode() || this.commonService.getCurrencyValue();

    this.salesflatOrder['baseCurrencyCode'] = currency;
    this.salesflatOrder['storeCurrencyCode'] = currency;
    this.salesflatOrder['globalCurrencyCode'] = currency;
    this.salesflatOrder['orderCurrencyCode'] = currency;

    this.salesflatOrder['customerGender'] = this.salesflatOrder['customerGender'] === 'Male' ? 1 : 0;
    this.salesflatOrder['baseGrandTotal'] = this.salesflatOrder['baseGrandTotal'] + this.delieveryCharge + this.consultationFees + this.getValidTip(this.tip);
    this.salesflatOrder['weight'] = this.totalWeigth;
    this.salesflatOrder['shippingAmount'] = this.delieveryCharge;
    this.salesflatOrder['salesFlatOrderItem'] = this.salesFlatOrderItem;
    this.salesflatOrder['salesFlatOrderAddress'] = this.selectedAddres;

    if (this.warehouseBasedAllocation == 1) {
      let warehouseId = localStorage.getItem("whs");
      this.salesflatOrder['warehouseId'] = warehouseId ? warehouseId : 1;
    } else {
      this.salesflatOrder['warehouseId'] = 1;
    }

    this.salesFlatInvoiceItem = [];

    if (this.orderDirectInvoiceEnable == 1) {
      this.salesFlatInvoice = { ...this.salesflatOrder };

      delete this.salesFlatInvoice['salesFlatOrderAddress'];
      delete this.salesFlatInvoice['salesFlatOrderItem'];
      delete this.salesFlatInvoice['salesFlatOrderPayment'];
      delete this.salesFlatInvoice['salesFlatQuoteItemOption'];
      delete this.salesFlatInvoice['salesFlatQuoteItem'];

      this.salesflatOrder.salesFlatInvoice = this.salesFlatInvoice;
      delete this.salesflatOrder.salesFlatInvoice.salesFlatInvoice;
    }

    let authourized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN']);

    if (guestLoginEnabled === "1" && authourized === null) {
      const address = this.salesflatOrder.salesFlatOrderAddress?.[0];
      if (address) {
        this.salesflatOrder['customerFirstname'] = address.firstName || '';
        this.salesflatOrder['customerEmail'] = address.lastName || '';
      } else {
        console.error('Missing address details. Cannot proceed.');
        return; // Stop the flow if no address is selected
      }
    }

    this.salesflatOrder['quoteId'] = this.salesflatOrder['entityId'];
    delete this.salesflatOrder['entityId'];
    delete this.salesflatOrder['customerGender'];
    delete this.salesflatOrder['salesFlatQuoteItemOption'];
    delete this.salesflatOrder['salesFlatOrderAddress'][0]?.gender;

    const length = this.salesflatOrder?.salesFlatOrderItem?.length - 1;

    this.salesflatOrder?.salesFlatOrderItem?.forEach((element, index) => {
      let itemOption = [];
      if (element.salesFlatQuoteItemOption?.length > 0) {
        element.salesFlatQuoteItemOption.forEach(opt => {
          opt['optionId'] = 0;
          itemOption.push(opt);
        });
        element['salesFlatOrderItemOption'] = itemOption;
        delete element['salesFlatQuoteItemOption'];
      }

      if (element['subscription']) {
        element['subscription']['orderItemId'] = 0;
      }

      element['quoteItemId'] = element['itemId'];
      delete element['itemId'];

      element['baseRowInvoiced'] = 0.0;
      element['isNominal'] = 0;
      element['rowInvoiced'] = 0.0;

      const subChild = element['subChild']?.[0];
      if (subChild) {
        subChild.baseRowInvoiced = 0.0;
        subChild.isNominal = 0;
        subChild.rowInvoiced = 0.0;
        subChild.orderId = 0.0;
        subChild['quoteItemId'] = subChild.itemId;
        delete subChild.itemId;
      }

      if (this.delieveryCharge > 0 && this.calculateShippingRateBasedOnVendors == 1) {
        element['shippingAmount'] = this.salesflatOrder['salesFlatQuoteItem'][index]['shippingAmount'];
        let extraCharge = 0.0;
        if (this.additionalDeliveryAmount > 0) {
          let weight = this.salesflatOrder['weight'];
          let deliveryAmount = this.salesflatOrder['additionalDeliveryAmount'];
          extraCharge = length > 0 ? (element.rowWeight / weight) * deliveryAmount : deliveryAmount;
        }
        element['shippingAmount'] += extraCharge;
      }

      if (this.orderDirectInvoiceEnable == 1) {
        element.qtyInvoiced = element.qty;
        element.subtotalInvoiced = element.subtotal;
        element.totalInvoiced = element.grandTotal;
        element.taxInvoiced = element.taxAmount;
        element.baseDiscountInvoice = element.qty;
        element.baseSubtotalInvoiced = element.baseSubtotal;
        element.baseTotalInvoiced = element.baseGrandTotal;
        element.baseTotalInvoicedCost = element.subtotal;
        element.discountInvoiced = element.qty;
        element.totalPaid = element.grandTotal;

        this.salesFlatInvoiceItem.push(element);
      }
    });

    delete this.salesflatOrder['salesFlatQuoteItem'];
    this.salesflatOrder['customerGender'] = 1;

    if (this.checkoutPageType === 2 || this.checkoutPageType === 5) {
      this.userNameEnabled = true;
    }

    if (this.orderDirectInvoiceEnable == 1) {
      this.formInvoiceJson();
      this.salesflatOrder['status'] = 'Invoiced';
      this.salesflatOrder.salesFlatInvoice.salesFlatInvoiceItem = this.salesFlatInvoiceItem;
    }

    console.log(this.salesflatOrder);
  }

  formInvoiceJson() {

    this.salesFlatInvoice['salesFlatInvoice'] = this.salesflatOrder;

    this.salesFlatInvoice['salesFlatInvoice'].entityId = 0;

    this.salesFlatInvoice['status'] = 'Invoiced';
    this.salesFlatInvoice['totalPaid'] = this.grandTotal + this.codPaymentCharge + this.consultationFees + this.getValidTip(this.tip);
    this.salesFlatInvoice['baseTotalPaid'] = this.salesflatOrder['baseGrandTotal'] + this.delieveryCharge
    this.salesFlatInvoice['remainingBalance'] = 0.0;
    this.salesFlatInvoice['partialPaidAmount'] = 0.0;
    this.salesFlatInvoice.subtotal = this.grandTotalWithoutShippingCharge;
    this.salesFlatInvoice.salesFlatQuoteItemOption = this.salesFlatOrderItemOption;
    this.salesFlatInvoice['deliveryOption'] = this.deliveryOptionControl.value
    this.salesFlatInvoice['grandTotal'] = this.grandTotal + this.codPaymentCharge + this.consultationFees + this.getValidTip(this.tip);
    this.salesFlatInvoice['additionalMedicalharge'] = this.consultationFees;
    this.salesFlatInvoice['tip'] = this.tip;
    this.salesFlatInvoice['orderAdditionalInfo'] = this.deliveryAdditionInfo.value;
    this.salesFlatInvoice['orderDeliveryTime'] = this.orderDeliveryTime;
    this.salesFlatInvoice['orderDeliveryType'] = this.deliveryType.value;
    this.salesFlatInvoice['printDateTime'] = this.newTime;
    this.salesFlatInvoice['entityId'] = 0;

    let currency = this.currencyConversionService.getCountryCode();

    if (currency == null) {

      currency = this.commonService.getCurrencyValue()

    }
    this.salesFlatInvoice['baseCurrencyCode'] = currency;
    this.salesFlatInvoice['storeCurrencyCode'] = this.currencyConversionService.getCountryCode();
    this.salesFlatInvoice['globalCurrencyCode'] = this.currencyConversionService.getCountryCode();
    this.salesFlatInvoice['orderCurrencyCode'] = this.currencyConversionService.getCountryCode();
    this.salesFlatInvoice['customerGender'] = this.salesflatOrder['customerGender'] == 'Male' ? 1 : 0;
    this.salesFlatInvoice['baseGrandTotal'] = this.salesflatOrder['baseGrandTotal'] + this.delieveryCharge + this.consultationFees + this.getValidTip(this.tip);
    this.salesFlatInvoice['weight'] = this.totalWeigth;
    this.salesFlatInvoice['shippingAmount'] = this.delieveryCharge;
    this.salesFlatInvoice['salesFlatInvoiceItem'] = this.salesFlatOrderItem


  }


  login(i) {

    this.index = 1;
  }

  change(i) {

    let previousIndex = this.index;
    this.index = i;


    if (this.paritialPaymentEnabled == 1 == null) {
      this.paritialPaymentEnabled = this.configData['partialPayment'];
    }
    if (this.paritialPaymentEnabled == 1 && i < 6) {


      this.partialPaymentControl.patchValue('Partial Payment')


      if (this.calculateParitialAmountPercent == 1) {

        let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
        this.paritialPaymentAmountControl.patchValue(value);
      } else {

        let value = this.paritialPaymentAmount;
        if (value > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
          this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
        } else {
          this.paritialPaymentAmountControl.patchValue(this.paritialPaymentAmount.toFixed(2))
        }
      }

      if (this.index == 7) {
        this.generateQr()
      }

    }

    if ((i <= 2)) {
      if (this.discountEnabled) {
        this.removeCoupon()
      }
      this.consultationFees = 0.0;
      this.medicalDeliveryOptionControl.reset();
      this.deliveryOptionMedicalObject.reset();
      this.mediaGallery = [];
      this.medicalDeliveryOptionControl.patchValue(1);
      if (this.deliveryOptionControl.value == 'Pick Up From Store') {
        this.deliveryAddressLabel = 'Pickup From A ' + this.storeName;

        this.medicalTitle = this.storeOptionList[0].title;
        this.medicalDeliveryOptionControl.patchValue(this.storeOptionList[0].type)
        this.deliveryOptionMedicalObject.patchValue(this.storeOptionList[0])
        if (this.medicalDeliveryOptionControl.value == 2 &&
          this.storeOptionList[0]['freeConsultation'] == 0 && this.storeOptionList[0]['consultationFees'] > 0) {

          this.consultationFees = this.storeOptionList[0]['consultationFees'];
        }
      } else {
        if (this.deliveryOptionList && this.deliveryOptionList.length > 0) {
          this.medicalDeliveryOptionControl.patchValue(this.deliveryOptionList[0].type)
          this.medicalTitle = this.deliveryOptionList[0].title;

        }
      }


    }
    else if (previousIndex == 4) {
      this.discountEnabled = false;
      this.discountAmt = 0;
      this.myForm.reset();
    } else if (this.index <= 5) {
      if (this.discountEnabled) {
        this.removeCoupon()
      }
    }


    if (this.index < 3) {
      this.consultationFees = 0.0;
    }

    if (this.index >= 2) {

      if (this.medicalDeliveryOptionControl.value == 2 && this.storeOptionList[0]['freeConsultation'] == 0 && this.storeOptionList[0]['consultationFees'] > 0) {

        if (this.deliveryOptionControl.value == 'Pick Up From Store') {
          this.consultationFees = this.storeOptionList[0]['consultationFees'];
        } else {

        }
      }


    }

  }

  checkoutList = [

    {
      "name": "login",
    },

    {
      "name": "Choose Delivery Options",
    },

    {
      "name": "Prescription Details",
    },


    {
      "name": "delivery address",
    },

    {
      "name": "Ordered Summary",
    },
    {
      "name": "Coupon",
    },
    {
      "name": "Payment Type"
    },
    {
      "name": "Delivery Tip"
    },
    {
      "name": "Delivery Instruction"
    },
    {
      "name": "Delivery Type"
    },
    {
      "name": "Delivery Slot",
    },
    {
      "name": "Payment Options"
    },

  ]

  deliveryOptions = [

    {
      "name": "Home Delivery",
    },

    {
      "name": "Pick Up From Store",
    },



  ]



  deliveryOptionControl = new UntypedFormControl('Home Delivery', []);

  tipControl = new UntypedFormControl(20, []);


  paritialPaymentAmountControl = new UntypedFormControl(0.0, [Validators.required]);

  medicalDeliveryOptionControl = new UntypedFormControl();
  deliveryOptionMedicalObject = new UntypedFormControl();


  paymentOptions: any = [];



  changesSaved = false;
  onUpdateServer() {
    this.changesSaved = true;
  }
  canDeactivate() {
    if (this.changesSaved) {
      return true;
    } else {
      return confirm('Do you want to discard changes');
    }
  }

  // radioChange(i, j) {
  //   this.defalutValue = i;
  //   this.paymentVendor = j;



  //   if (this.paymentVendor == "oppwa") {
  //     this.payment = "oppwa";
  //     this.salesFlatOrderPayment = {
  //       salesPaymentTransaction: [{
  //         txn_id: 0,
  //         txn_type: "customer",
  //         isClose: true
  //       }],
  //       salesFlatOrderPayment: {
  //         method: 'oppwa',
  //         additionalInformation: null

  //       },
  //       paypalPaymentStatus: "Successful"
  //     }



  //   }
  //   this.formPaymentData();


  // }


  setPaymentData(paymentMode, type) {
    this.additionData = ''


    let paymentObject = {
      salesPaymentTransaction: [{
        txn_id: '',
        txn_type: "customer",
        isClose: true
      }],
      salesFlatOrderPayment: {
        method: paymentMode,
        additionalInformation: this.additionData

      },
      paypalPaymentStatus: "Successful"

    }
    this.payment = "ccavenue";
    this.salesFlatOrderPayment = {
      salesPaymentTransaction: [{
        txn_id: 0,
        txn_type: "customer",
        isClose: true
      }],
      salesFlatOrderPayment: {
        method: type,
        additionalInformation: null

      },
      paypalPaymentStatus: "Successful"
    }
    this.formOrderJson();
    this.paymentResponceCCAvenue(paymentObject);
    let object1 = {
      "extOrderId": this.salesflatOrder['extOrderId'],
      "conversion-id": this.conversionId,
      "grandTotal": this.salesflatOrder['grandTotal'],
      "skuList": this.skuList,
      "shareChatId": this.shareChatId
    }
    let value = this.ecryptService.encryptionAES(JSON.stringify(object1));




    this.salesflatOrder['customerGender'] = this.salesflatOrder['customerGender'] == "Male" ? 1 : 0;

    sessionStorage.setItem(Constant.CONVERSION_TRACKING, value)
  }

  paymentResponce(i) {

    if (i.paypalPaymentStatus == "COMPLETED") {

      this.payment = 'paypal';
      this.salesflatOrder['salesFlatOrderPayment'] = i.salesFlatOrderPayment;
      this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = i.salesPaymentTransaction;
      this.placeOrder();

    }
    else {
      this.snackBar.open("Payment Failed", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
    }
  }

  paymentResponceRazorPAy(i) {
    this.payment = 'razorPay';
    this.salesflatOrder['salesFlatOrderPayment'] = i.salesFlatOrderPayment;
    this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = i.salesPaymentTransaction;
    this.placeOrder();

  }

  paymentResponcePayu(i) {
    this.payment = 'payu';
    this.salesflatOrder['salesFlatOrderPayment'] = i.salesFlatOrderPayment;
    this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = i.salesPaymentTransaction;
    this.placeOrder();

  }

  paymentResponceStripe(i) {
    this.payment = 'stripe';
    this.salesflatOrder['salesFlatOrderPayment'] = i.salesFlatOrderPayment;
    this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = i.salesPaymentTransaction;
    this.placeOrder();

  }

  paymentResponceCCAvenue(i) {
    this.payment = 'ccavenue';
    this.salesflatOrder['salesFlatOrderPayment'] = i.salesFlatOrderPayment;
    this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = i.salesPaymentTransaction;
    //  this.placeOrder();

  }


  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  moveNext() {


    if (this.paritialPaymentEnabled == 1) {

      if (this.calculateParitialAmountPercent == 1) {

        let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
        this.paritialPaymentAmountControl.patchValue(value);
      } else {

        let value = this.paritialPaymentAmount;
        if (value > (this.grandTotal + this.consultationFees)) {
          this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
        }
      }
      this.index = 6;
    } else if (this.enableDeliveryTip == 1) {
      this.index = 7;

    } else if (this.enableDeliveryInstuction == 1) {
      this.index = 8;

    } else if (this.deliverySlotEnable == 1) {
      this.index = 9;

    }
    else {
      this.index = 10;

      this.formPaymentData();

      this.generateQr();
    }

    if (!this.discountEnabled) {
      this.myForm.reset();
    }
  }

  moveNextTip() {

    console.log(this.index, "index");

    if (this.enableDeliveryInstuction == 1) {
      this.index = 9;
    } else if (this.deliverySlotEnable == 1) {
      this.index = 10;
    } else {
      this.index = 11;
      this.formPaymentData();

      this.generateQr();

    }

    console.log(this.index, "index");

  }

  moveNextdelevery() {

    if (this.deliveryType.value == 'Express') {
      this.index = 11;
    } else {

      if (this.deliverySlotEnable == 1) {
        this.index = 10;
      } else {
        this.index = 11;

        this.formPaymentData();

        this.generateQr();
      }

    }

    console.log(this.index, "index");
  }


  onDeliveryTypeChange(event: MatSelectChange) {

    const type = event.value;

    if (type == 'Express') {


      const now = new Date();

      const formattedDate = this.datePipe.transform(now, 'yyyy-MM-dd'); // "2025-07-12"
      const time24 = now.toTimeString().split(' ')[0].slice(0, 5);       // "01:50"
      const timeWithAMPM = this.get12HourTimeWithAMPM(time24);          // "1:50 AM"
      const formattedTime = this.convertToHHmmss(timeWithAMPM);         // "01:50:00"

      const dateTimeString = `${formattedDate} ${formattedTime}`;       // "2025-07-12 01:50:00"

      this.orderDeliveryTime = dateTimeString;

      console.log("orderDeliveryTime:", this.orderDeliveryTime);

      this.deliverySlotEnable = 0;

      this.index = 11;


    } else {

      this.index = 10;

      this.deliverySlotEnable = 1;

      this.deliverySlotsEnable = true;
    }

  }


  get12HourTimeWithAMPM(time24: string): string {
    const [hourStr, minuteStr] = time24.split(':');
    let hours = parseInt(hourStr, 10);
    const minutes = parseInt(minuteStr, 10);

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // convert 0 or 12 to 12

    return `${hours}:${minuteStr} ${ampm}`;
  }

  getAboutData() {

  }
  moveNextPayment() {


    this.index = 11;
    this.formPaymentData();

    this.generateQr();




  }




  onCouponSelected(code: any) {
    this.promoCode = code;
    this.myForm.get('name')?.setValue(code);
    this.isPromoApplied = false;
    if (code != null) {
      this.applyCouponCode(2);
    }
    else {
      // this.GrandTotal = this.GrandTotal  -this.discountAmt;
      // this.discountAmt = 0;
      this.removeCoupon();
      this.snackBar.open('Coupon Removed Successfully!', '🗑️', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
    }

  }
  applyCouponCode(value) {

    if ((this.myForm.valid && value == 1) || value == 2) {
      this.categoryId = [];
      this.totalQty == 0.0;
      let indexx = 0;
      this.salesFlatOrderItem.salesFlatQuoteItem.forEach(element => {

        if (indexx == 0) {

          // this.categoryId = '$.categoryId' + ' = ' + element['categoryId'];

          this.categoryId.push(element['categoryId'])
          this.totalQty = element['qty'];
        }
        else {
          this.categoryId.push(element['categoryId'])

          this.totalQty = this.totalQty + element['qty'];
        }


        indexx++;

      });

      this.couponCodevalue = this.myForm.value.name;
      let coupon = {
        "couponCode": this.couponCodevalue,
        "categoryId": this.categoryId,
        "subTotal": this.grandTotalWithoutShippingCharge,
        "grandTotal": this.grandTotal,
        "totalQty": this.totalQty,
        "weight": this.totalWeigth,
        "shippingMethod": this.paymentOptions[this.defalutValue] != undefined ? this.paymentOptions[this.defalutValue].name : 'store pickup',
        "shippingRegion": this.regionId,
        "country": this.countryId,
        "customerId": this.salesflatOrder['customerId']
      }

      let url = "applyCoupon"
      if (value == 2) {
        let refId = sessionStorage.getItem(Constant.REFERAL_ID);
        let refProductId = sessionStorage.getItem(Constant.REFERRED_PRODUCT_ID);
        if (refId != null) {
          coupon['referalId'] = refId;

          url = "applyReferalDiscount"

        }
      }
      this.checkOut[url](coupon).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            let amt = response['data']['discountAmt'];
            this.couponResult = response['data'];
            this.discountEnabled = true;
            this.discountAmt = response['data']['discountAmt'];
            this.grandTotal = this.grandTotal - amt;
            this.GrandTotal = this.GrandTotal - amt;
            this.grandTotalWithoutShippingCharge = this.grandTotalWithoutShippingCharge;



            if (this.paritialPaymentEnabled == 1) {

              if (this.calculateParitialAmountPercent == 1) {

                let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
                this.paritialPaymentAmountControl.patchValue(value);
              } else {

                let value = this.paritialPaymentAmount;
                if (value > (this.grandTotal + this.consultationFees)) {
                  this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
                }
              }
              this.index = 6;
            } else {

              if (this.enableDeliveryTip == 1) {
                this.index = 7;
              } else {
                this.index = 10;
              }

              this.generateQr();

              this.formPaymentData()

            }

          }
          else {

            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => { });

    } else {
      this.myForm.markAllAsTouched();
    }

  }
  comment = new UntypedFormControl('', []);

  removeCoupon() {
    this.grandTotal = this.grandTotal + this.discountAmt;
    this.discountEnabled = false;
    //this.grandTotalWithoutShippingCharge = this.grandTotalWithoutShippingCharge + this.discountAmt;

    this.myForm.reset();
  }




  Alldata: any =
    {
      "ClientInfo": {
        "UserName": "",
        "Password": "",
        "Version": "v1.0",
        "AccountNumber": "36669982",
        "AccountPin": "331431",
        "AccountEntity": "BOM",
        "AccountCountryCode": "IN",
        "Source": 24
      },
      "OriginAddress": {
        "Line1": "Test Address",
        "Line2": "",
        "Line3": "",
        "City": "",
        "StateOrProvinceCode": "",
        "PostCode": "110001",
        "CountryCode": "IN",
        "Longitude": 0,
        "Latitude": 0,
        "BuildingNumber": null,
        "BuildingName": null,
        "Floor": null,
        "Apartment": null,
        "POBox": null,
        "Description": null
      },
      "DestinationAddress": {
        "Line1": "Test Address",
        "Line2": "",
        "Line3": "",
        "City": "Sydney",
        "StateOrProvinceCode": "",
        "PostCode": "2000",
        "CountryCode": "AU",
        "Longitude": 0,
        "Latitude": 0,
        "BuildingNumber": null,
        "BuildingName": null,
        "Floor": null,
        "Apartment": null,
        "POBox": null,
        "Description": null
      },
      "ShipmentDetails": {
        "Dimensions": null,
        "ActualWeight": {
          "Unit": "KG",
          "Value": 0.5
        },
        "ChargeableWeight": null,
        "DescriptionOfGoods": "Books",
        "GoodsOriginCountry": "IN",
        "NumberOfPieces": 1,
        "ProductGroup": "EXP",
        "ProductType": "PPX",
        "PaymentType": "P",
        "PaymentOptions": "",
        "CustomsValueAmount": null,
        "CashOnDeliveryAmount": null,
        "InsuranceAmount": null,
        "CashAdditionalAmount": null,
        "CashAdditionalAmountDescription": "",
        "CollectAmount": null,
        "Services": "",
        "Items": []
      },
      "Transaction": {
        "Reference1": "",
        "Reference2": "",
        "Reference3": "",
        "Reference4": "",
        "Reference5": ""
      }
    }

  goToCart() {
    this.router.navigate(['/cart']);
  }

  goToHomePage() {
    this.router.navigate(['/'])
  }

  goToShopping() {
    this.dialog.closeAll();
  }

  getAllPaymentModes() {
    this.paymentService.getAllPaymentModes().subscribe(
      res => {

        let list = [];

        list = res;

        if (res.length > 0) {


          this.paymentModes = res;
        } else {
          this.paymentModes = [

            {
              "name": "Cash On Delivery",
              "type": "cashon"
            },

          ]
        }
        this.qrCodePaymentMode = this.paymentModes.find(mode => mode.type === 'qrcode');



      }, error => {

      }
    );


  }


  @ViewChild('helpPopUp') helpPopUp: TemplateRef<any>;

  openHelpPopup(paymentOption, grandTotal, type) {

    if (paymentOption.type == 'cashon' && (paymentOption.minimumValue != 0.0 && grandTotal > paymentOption.minimumValue)) {
      this.helpDescription = paymentOption.description;
      if (window.innerWidth > 768) {

        let dialogRef = this.dialog.open(this.helpPopUp, {
          width: '700px',
          disableClose: true,
        });
        dialogRef.disableClose = false;
        dialogRef.afterClosed().subscribe(result => {

        })
      } else {
        let dialogRef = this.dialog.open(this.helpPopUp, {
          minWidth: "100vw",
          height: "100vh",

        });
        dialogRef.disableClose = false;
        dialogRef.afterClosed().subscribe(result => {



        })
      }
    }
  }

  CashOnDelivery() {
    this.payment = "Cod"
    this.grandTotal = this.grandTotal
    this.placeOrder();
  }
  finalPay() {

    if (this.addressNotFilled == true) {
      this.currentView = 'address';
      return
    }
    else if (!this.selectedPaymentOptionName) {
      this.currentView = 'payment';
    }

    if (this.selectedPaymentOptionName === 'COD') {
      this.CashOnDelivery();
    } else if (this.selectedPaymentOptionName === 'Easebuzz') {
      // Call Easebuzz logic here
    } else if (this.selectedPaymentOptionName === 'PhonePe UPI') {
      this.phonePeCheckout();
    } else if (this.selectedPaymentOptionName === 'Razorpay') {
      this.createRazorpayOrder();
    }
  }



  moveNextSales() {


    if (this.prescriptionRequired) {


      this.index = 2;
    } else {
      this.index = 3
    }



    if (this.deliveryOptionControl.value == 'Pick Up From Store') {
      this.deliveryAddressLabel = 'Pickup From A ' + this.storeName;

      this.medicalTitle = this.storeOptionList[0].title;
      this.medicalDeliveryOptionControl.patchValue(this.storeOptionList[0].type)
      this.deliveryOptionMedicalObject.patchValue(this.storeOptionList[0])
    }
    else {
      if (this.deliveryOptionList && this.deliveryOptionList.length > 0) {
        this.medicalDeliveryOptionControl.patchValue(this.deliveryOptionList[0].type)
        this.medicalTitle = this.deliveryOptionList[0].title;

      }
    }

    if (this.medicalDeliveryOptionControl.value == 2 && this.storeOptionList[0]['freeConsultation'] == 0 && this.storeOptionList[0]['consultationFees'] > 0) {

      this.consultationFees = this.storeOptionList[0]['consultationFees'];
    }
  }

  radioChangedeliveryOption(value) {



    this.deliveryOptionControl.patchValue(value)

  }


  radioChangedeliveryOptionMedical(value) {
    this.deliveryOptionMedicalObject.patchValue(value);
    this.medicalDeliveryOptionControl.patchValue(value.type)

    this.medicalTitle = value.title;

    if (this.medicalDeliveryOptionControl.value == 2 && value['freeConsultation'] == 0 && value['consultationFees'] > 0) {
      this.consultationFees = value['consultationFees'];
    } else {
      this.consultationFees = 0.0;
    }


  }


  getAllMedicalDeliveryOption() {
    this.configService.medicalDeliveryOption().subscribe(
      res => {


        this.deliveryOptionList = [];
        this.storeOptionList = [];

        res.forEach(element => {



          if (element['visibility'] == 1) {

            this.deliveryOptionList.push(element);

          } else if (element['visibility'] == 2) {
            this.storeOptionList.push(element)
          }
          else if (element['visibility'] == 3) {
            this.deliveryOptionList.push(element);
            this.storeOptionList.push(element)
          }
        });

        this.deliveryOptionMedicalObject.patchValue(this.deliveryOptionList[0]);

        if (this.storeOptionList && this.storeOptionList.length > 0) {
          this.medicalDeliveryOptionControl.patchValue(this.storeOptionList[0].type);
        } else {
          this.deliveryOptionMedicalObject.patchValue(this.deliveryOptionList[0]);
        }

        this.medicalDeliveryOptionControl.patchValue(this.storeOptionList[0].type);
        this.medicalDeliveryOptionControl.patchValue(this.deliveryOptionList[0].type);



      }, error => {

      }
    );
  }

  moveNextItem() {


    if (this.medicalDeliveryOptionControl.value == 1 && this.mediaGallery == 0) {


      this.snackBar.open("Please Upload Prescriptions to Continue", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
    } else {

      this.index = 3;
    }

  }

  getResult(event) {


    if (this.mediaGallery.length <= 0) {
      this.mediaGallery = event.productEntityMediaGallery;
    } else {
      this.mediaGallery = this.mediaGallery.concat(event.productEntityMediaGallery);
    }



  }

  deleteImage(value, index) {

    this.imagesToRemoved.push(value);

    if (this.mediaGallery[index].valueId != '') {
      this.configService.deleteImage(this.imagesToRemoved).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.mediaGallery.splice(index, 1);
            this.mediaGallery = this.mediaGallery;
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.text = "Save"
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => { });
    } else {
      this.mediaGallery.splice(index, 1);
    }
  }

  @ViewChild('imagePreviewDialog') imagePreviewDialog: TemplateRef<any>;


  openPreview(value) {


    if (this.mediaGallery.length > 0) {
      this.zoomImage = value;
      if (window.innerWidth > 768) {
        let dialogRef = this.dialog.open(this.imagePreviewDialog, {
          disableClose: true,
          width: '790px',
          height: '400px',
        });
        dialogRef.afterClosed().subscribe((result) => { });
      } else {
        let dialogRef = this.dialog.open(this.imagePreviewDialog, {
          minWidth: '100vw',
          height: '100vh',
        });
        dialogRef.afterClosed().subscribe((result) => { });
      }
    } else {
      this.snackBar.open('No Products added, add some products first', '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 3000,
      });
    }
  }

  radioChangeParitialPayment(value) {


    this.userNameEnabled = false;
    this.partialPaymentControl.patchValue(value)


    if (this.calculateParitialAmountPercent == 1) {

      let value = (this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) * (this.paritialPaymentAmount / 100);
      this.paritialPaymentAmountControl.patchValue(value);
    } else {

      let value = this.paritialPaymentAmount;
      if (value > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
        this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
      } else {
        this.paritialPaymentAmountControl.patchValue(this.paritialPaymentAmount.toFixed(2))
      }
    }
    this.formOrderJson()

  }


  moveNextMenu() {

    if (this.enableDeliveryTip == 1) {
      this.index = 7;
    } else if (this.enableDeliveryInstuction == 1) {
      this.index = 8;
    }
    else if (this.deliverySlotEnable == 1) {
      this.index = 9;
    }
    else if (this.paritialPaymentAmountControl.valid &&
      this.partialPaymentControl.value == 'Partial Payment') {
      this.formPaymentData();
      this.index = 10;
      this.generateQr();
    } else {

      if (this.partialPaymentControl.value != 'Partial Payment') {
        let value = 0;

        this.paritialPaymentAmountControl.patchValue(value.toFixed())
        this.index = 10;

        this.formPaymentData()

        this.generateQr()
      } else {
        this.paritialPaymentAmountControl.markAllAsTouched();
      }

    }

  }


  orderEditValidation = {
    'paymentFormControls': [
      { type: 'required', message: 'Please fill out this field.' },
      { type: 'pattern', message: 'Enter a Valid Email Format' },
    ],
  }


  checkContains(code) {
    let value = this[code].value;


    value = value.replace(/[^0-9.]/g, '');

    if (value != "") {
      value = parseFloat(value);

    }
    if (value == "" || value == 'NaN') {
      this.paritialPaymentAmountControl.reset()
    } else {

      if (value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
        if (value < this.paritialPaymentAmount) {

          let amt = this.paritialPaymentAmount

          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            amt = (this.grandTotal + this.consultationFees) - 1;
          }
          let message = "Paritial Amount Can't be Lowerthan this " + amt
          this.snackBar.open(message, '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000,
          });
          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }

        } else {
          if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
          } else if (this.paritialPaymentAmount < value && value < (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
            this.paritialPaymentAmountControl.patchValue(value.toFixed(2));
          }
          else {
            this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
          }
        }

      } else {
        if (this.paritialPaymentAmount > (this.grandTotal + this.consultationFees + this.getValidTip(this.tip))) {
          this.paritialPaymentAmountControl.patchValue((this.grandTotal + this.consultationFees + this.getValidTip(this.tip)) - 1);
        } else {
          this[code].patchValue(this.paritialPaymentAmount.toFixed(2))
        }

      }



    }

  }

  getSku(event) {

    this.skuList = event;

  }


  paymentResponceQrScan() {

    if (this.qrCodeReference.valid) {

      let paymentInformation = {}

      if (this.paritialPaymentEnabled == 1) {

        paymentInformation = {
          Transaction_Upi_id: this.qrCodeReference.value,
          currency: 'INR',
          Partial_Payment: 'Yes',
          Partial_Paid_Amount: this.paritialPaymentEnabled == 1 ?
            this.paritialPaymentAmountControl.value : this.grandTotal + this.consultationFees + this.getValidTip(this.tip)

        }
      } else {
        paymentInformation = {
          Transaction_Upi_id: this.qrCodeReference.value,
          currency: 'INR',

        }
      }

      let additionData = JSON.stringify(paymentInformation)

      let paymentObject = {
        salesPaymentTransaction: [{
          txn_id: this.partialPaymentControl.value,
          txn_type: "customer",
          isClose: true
        }],
        salesFlatOrderPayment: {
          method: 'razor_pay',
          additionalInformation: additionData

        },
        paypalPaymentStatus: "Successful"

      }
      if (this.paritialPaymentEnabled == 1) {


        this.salesflatOrder['salesFlatOrderPayment'] = paymentObject.salesFlatOrderPayment;
        this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = paymentObject.salesPaymentTransaction;
      } else {
        this.salesflatOrder['salesFlatOrderPayment'] = paymentObject.salesFlatOrderPayment
        this.salesflatOrder['salesFlatOrderPayment']['salesPaymentTransaction'] = paymentObject.salesPaymentTransaction;
      }
      this.payment = 'CustomQr';

      this.placeOrder();
    } else {
      this.qrCodeReference.markAllAsTouched();
    }


  }

  copyInputMessage(i) {
    this.clipboard.copy(`${i}`);
    this.snackBar.open(`Upi Id Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

  }

  imageURL: SafeUrl
  generateQr() {
    let index = this.paymentModes.findIndex(x => x.type == 'qrcode');

    if (index > 0) {
      if (this.paymentModes[index].upiId != undefined) {
        let value = this.paymentModes[index].upiId;
        let desc = this.paymentModes[index].description
        upiqr({
          payeeVPA: value,
          payeeName: desc,
          amount: this.partialPaymentControl.value == 'Partial Payment' && this.paritialPaymentEnabled == 1 ?
            this.paritialPaymentAmountControl.value : this.grandTotal + this.consultationFees + this.getValidTip(this.tip)
        })
          .then((upi) => {
            this.imageURL = this.sanitizer.bypassSecurityTrustUrl(upi.qr);
            this.upiLink = upi.intent
            //  console.log(upi.qr);      // data:image/png;base64,eR0lGODP...
            //    console.log(upi.intent);  // upi://pay?pa=john@upi&pn=JOHN DOE
          })
          .catch(err => {
            //   console.log(err);
          });
      }
    }


  }

  navigate() {

    window.location.href = this.upiLink;

  }

  getAddressDeliverable(value) {

    this.userNameEnabled = value;

  }

  formPaymentData() {
    if (this.paymentModes[this.defalutValue].name == "cc-avenue"
      || this.paymentModes[this.defalutValue].name == "Phone-Pe") {
      this.formOrderJson();

      if (this.paymentModes[this.defalutValue].name == "cc-avenue") {

        this.setPaymentData('CCAvenue', 'ccavenue');
      } else if (this.paymentModes[this.defalutValue].name == "Phone-Pe") {

        this.setPaymentData('Phone-Pe', 'phonePe');
      }

    }
  }

  selectedDay: any;

  selectDay(day: any) {
    this.selectedDay = day;

    console.log(this.selectedDay);

  }


  onTabChange(event: MatTabChangeEvent) {
    const selectedTabIndex = event.index;

    this.selectedDay = this.deliverySlots[selectedTabIndex];

    if (selectedTabIndex === 0 && this.deliverySlotEnable == 1) {
      this.getAllDeliverySlots();
    }

  }


  selectedSlots(value, day) {


    this.deliverySlotsEnable = true;


    this.selectedTime = value;

    const originalDate = day;

    // Create a new Date object from the original date
    const dateObj = new Date(originalDate);

    const formattedDate = this.datePipe.transform(dateObj, 'yyyy-MM-dd');

    const timeString = value;

    const formattedTime = this.convertToHHmmss(timeString)


    console.log(formattedTime);


    const dateObj1 = new Date(`${formattedDate} ${formattedTime}`);

    console.log(formattedTime);


    this.orderDeliveryTime = dateObj1;

    console.log(this.orderDeliveryTime);
    console.log(this.printTimeInOrder);


    const date = new Date(dateObj1);


    // Subtracting minutes
    date.setMinutes(date.getMinutes() - this.printTimeInOrder);

    // Create a new Date object for formatting
    let newTime = new Date(date);

    // Format the new time
    let printTime = this.datePipe.transform(newTime, 'yyyy-MM-dd HH:mm:ss'); // Use HH for 24-hour format

    let orderTime = this.datePipe.transform(dateObj1, 'yyyy-MM-dd HH:mm:ss'); // Use HH for 24-hour format

    this.newTime = printTime;

    this.orderDeliveryTime = orderTime;

    console.log(printTime); // Outputs the formatted date string
    console.log(`New Time: ${printTime}`);
  }

  convertToHHmmss(timeString: string): string {
    const [time, modifier] = timeString.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier.toUpperCase() === "PM" && hours < 12) {
      hours += 12;
    }
    if (modifier.toUpperCase() === "AM" && hours === 12) {
      hours = 0;
    }

    // Format hours, minutes, and seconds
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = '00'; // Assuming you want to set seconds to 00

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }



  getAllDeliverySlots() {
    this.deliverySlotsService.getAllDeliverySlotsDropDown().subscribe(
      res => {

        this.deliverySlots = res;

        if (this.deliverySlots.length > 0) {

          this.loadDays()
        }

      }, error => {

      }
    );


  }
  days: any[] = [];
  currentDate = new Date();

  loadDays() {
    const startDate = new Date();
    for (let i = 0; i < this.deliverySlotPeriod; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      this.days.push({
        dayId: i + 1,
        dayDate: date,
        dayName: date.toLocaleString('default', { weekday: 'long' }),
        isActive: 1,
        slot: [] // Placeholder for slots
      });
    }
    this.populateSlots();
  }

  // populateSlots() {
  //   const todayString = this.currentDate.toISOString().split('T')[0]; // Get today's date as YYYY-MM-DD

  //   this.days.forEach(day => {
  //     // Find the current day's data based on the dayName
  //     const currentDayData = this.deliverySlots.find(slotDay =>
  //       slotDay.dayName.toLowerCase() === day.dayName.toLowerCase()
  //     );

  //     if (currentDayData) {
  //       currentDayData.slot.forEach(slot => {
  //         // Properly parse the start time
  //         const slotStartTime = this.parseTime(slot.startTime);

  //         if (slotStartTime) { // Check if parsing was successful
  //           // Check if today and adjust time for the current day
  //           if (day.dayDate.toDateString() === this.currentDate.toDateString()) {
  //             const currentTime = new Date();
  //             currentTime.setMinutes(currentTime.getMinutes() + this.deliverySlotTiming); // Add 30 minutes

  //             // Only add slots that start after the adjusted current time
  //             if (slotStartTime > currentTime) {
  //               day.slot.push(slot);
  //             }
  //           } else {
  //             // For future days, add all slots
  //             day.slot.push(slot);
  //           }
  //         } else {
  //           console.warn(`Invalid time format for slot: ${slot.startTime}`);
  //         }
  //       });
  //     } else {
  //       let index = this.days.findIndex(x => x.dayName == day.dayName);
  //       this.days.splice(index, 1);
  //     }
  //   });

  //   this.selectedDay = this.days[0];

  //   this.selectedSlots(this.days[0].slot[0].startTime, this.days[0].dayDate)

  //   console.log(this.days); // Debugging output
  // }

  populateSlots() {
    const todayString = this.currentDate.toISOString().split('T')[0]; // Get today's date as YYYY-MM-DD

    this.days.forEach(day => {
      // Find the current day's data based on the dayName
      const currentDayData = this.deliverySlots.find(slotDay =>
        slotDay.dayName.toLowerCase() === day.dayName.toLowerCase()
      );

      if (currentDayData) {
        currentDayData.slot.forEach(slot => {
          // Properly parse the start time
          const slotStartTime = this.parseTime(slot.startTime);

          if (slotStartTime) { // Check if parsing was successful
            // Check if today and adjust time for the current day
            if (day.dayDate.toDateString() === this.currentDate.toDateString()) {
              const currentTime = new Date();
              currentTime.setMinutes(currentTime.getMinutes() + this.deliverySlotTiming); // Add dynamic timing

              // Only add slots that start after the adjusted current time
              if (slotStartTime > currentTime) {
                day.slot.push(slot);
              }
            } else {
              // For future days, add all slots
              day.slot.push(slot);
            }
          } else {
            console.warn(`Invalid time format for slot: ${slot.startTime}`);
          }
        });
      } else {
        let index = this.days.findIndex(x => x.dayName == day.dayName);
        this.days.splice(index, 1);
      }
    });

    this.selectedDay = this.days[0];

    if (this.days[0].slot.length > 0) {
      this.selectedSlots(this.days[0].slot[0].startTime, this.days[0].dayDate);
    }

    console.log(this.days);
  }

  // Helper function to parse time in "hh:mm AM/PM" format
  private parseTime(timeString: string): Date | null {
    const timeParts = timeString.match(/(\d+):(\d+)\s*([APM]{2})/);
    if (!timeParts) {
      return null; // Invalid format
    }

    let hours = parseInt(timeParts[1], 10);
    const minutes = parseInt(timeParts[2], 10);
    const period = timeParts[3];

    // Convert to 24-hour format
    if (period.toUpperCase() === 'PM' && hours < 12) {
      hours += 12;
    } else if (period.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }

    // Create a date object for the time
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    return date;
  }


  backToPage() {
    this.location.back();
  }


  showBillSummaryDetails: boolean = false;

  toggleBillSummary(): void {
    this.showBillSummaryDetails = !this.showBillSummaryDetails;
  }

  closeCheckoutPopup() {
    this.location.back(); // or your logic to close the panel
  }
  isBillingExpanded = true;
  toggleBilling(): void {
    this.isBillingExpanded = !this.isBillingExpanded;
  }


  deliveryTypeOptions: any = [
    { "value": "Standard", "viewValue": "Standard" },
    { "value": "Express", "viewValue": "Express" },
  ]

  deleteItemFromCart(itemId, i) {

    for (let j = 0; j < localStorage.length; j++) {
      const key = localStorage.key(j);
      if (key && key.includes('message')) {
        localStorage.removeItem(key);
        j--;
      }
    }

    // localStorage.removeItem('message'+ this.firstFormGroup.value.entityId);

    this.prescriptionRequired = false;

    let quoteId = this.cartFormGroup.value.entityId

    let salesFlatQuoteItem = this.cartFormGroup.value.salesFlatQuoteItem[i]
    this.cartService.deleteItemFromCart(quoteId, itemId, salesFlatQuoteItem).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.updateToolbar();
          this.spinnerCartDecrease[i] = false;
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.cartFormGroup.reset();
          let cache = "update"
          this.getCartItems(cache);
          localStorage.removeItem(Constant.CART_COUNT)
          this.cartServices.responseCache1 = new Map();
          if (response['data'].salesFlatQuoteItem.length == 0) {

            let data = {

              url: 'none',
              whatsappNavigated: this.isWhatsApp,
              type: 4

            }
            this.dialogRef.close({ event: 'add', data: data })
          }

        }
        else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }

      },
      (err) => { });

  }

}
